<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <form @submit.prevent="updateBooking">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="h2"> #B-{{ booking.id }} ({{ types[booking.type] }}) - {{ booking.client }} - {{ booking.dropoff_address.name }}
                            <span v-if="booking.recurring_data">
                                          ({{ booking.recurring_data.name }})
                            </span>
                        </div>
                        <div v-if="booking.original_booking_id" class="h3">
                            Copy:
                            <a :href="`/bookings/${booking.original_booking_id}/edit`">
                                #B-{{ booking.original_booking_id }}-{{ booking.copy }}
                            </a>
                        </div>
                        <div class="my-2">
                            <div class="rebooking" v-if="booking.rebooking_from">
                                Rebooking of booking {{ booking.rebooking_from }}
                            </div>
                            <div class="rebooking" v-if="booking.rebooking_to">
                                Rebooked in booking {{ booking.rebooking_to }}
                            </div>
                            <div class="rebooking" v-if="booking.order_deliveries && booking.order_deliveries.length">
                                Other deliveries of this order:
                                <a v-for="delivery in booking.order_deliveries"
                                   :key="delivery.id"
                                   class="mr-1"
                                   :href="`/bookings/${delivery.id}/edit`">
                                    #B-{{ delivery.id }}
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 d-flex justify-content-left align-items-left">
                                <div class="btn-group status-icons float-right shadow-sm" role="group" aria-label="">
                                    <div
                                        class="btn  d-flex align-items-center float-left status-block status-text"
                                        :class="booking.status_id===1 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                                   <span class="material-icons-outlined cursor-pointer mr-1"
                                                         title="person_add">person_add</span>
                                        <span class="status-label">New</span>
                                    </div>


                                    <div
                                        class="btn  d-flex align-items-center float-left status-block status-text"
                                        :class="booking.status_id===2 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                                  <span class="material-icons-outlined cursor-pointer mr-1"
                                                        title="done">done</span>
                                        <span class="status-label">Confirmed</span>
                                    </div>

                                    <div v-if="booking.is_booking_pickup_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===3 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1"
                                              title="done">archive</span>
                                        <span class="status-label">Ready for pickup</span>
                                    </div>


                                    <div v-if="booking.is_booking_pickup_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===5 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                              <span class="material-icons-outlined cursor-pointer mr-1"
                                                    title="done">local_shipping</span>
                                        <span class="status-label">On pickup</span>
                                    </div>

                                    <div v-if="booking.is_booking_linehaul_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===6 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                              <span class="material-icons-outlined cursor-pointer mr-1"
                                                    title="done">flight_takeoff</span>
                                        <span class="status-label">Awaiting linehaul</span>
                                    </div>

                                    <div v-if="booking.is_booking_dropoff_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===7 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1"
                                              title="done">unarchive</span>
                                        <span class="status-label">Ready for delivery</span>
                                    </div>

                                    <div v-if="booking.is_booking_dropoff_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===9 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                              <span class="material-icons-outlined cursor-pointer mr-1"
                                                    title="done"> local_shipping</span>
                                        <span class="status-label">On delivery</span>
                                    </div>

                                    <div v-if="booking.status_id !== 11 && booking.status_id !== 12">
                                        <div
                                            class="btn  d-flex align-items-center float-left status-block status-text"
                                            :class="booking.status_id===10 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                        >
                                            <span class="material-icons-outlined cursor-pointer mr-1"
                                                  title="done">verified</span>
                                            <span class="status-label">Delivered</span>
                                        </div>
                                    </div>
                                    <div
                                        v-else-if="booking.status_id === 11"
                                        class="btn  d-flex align-items-center float-left status-block status-block-error status-text"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1"
                                              title="done">cancel</span>
                                        <span class="status-label">Failed</span>
                                    </div>
                                    <div
                                        v-else-if="booking.status_id === 12"
                                        class="btn  d-flex align-items-center float-left status-block status-block-error status-text"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1"
                                              title="done">cancel</span>
                                        <span class="status-label">Rejected</span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="booking.status_id === 11"
                                class="mt-4 ml-3 btn add-warehouse btn-success"
                                @click="redirectToCreateRebookingPage">
                                Create rebooking
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2" v-if="booking.depends_on || booking.child_booking">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                <div class="h3 mb-0">Connected booking</div>
                            </div>
                            <div class="font-weight-semi-bold">
                                <div v-if="booking.depends_on">
                                    <a :href="`/bookings/${booking.depends_on}/edit`" class="invisible-link">
                                        #B-{{ booking.depends_on }}
                                    </a>
                                </div>
                                <div v-if="booking.child_booking">
                                    <a :href="`/bookings/${booking.child_booking}/edit`" class="invisible-link">
                                        #B-{{ booking.child_booking }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2" v-if="!booking.depends_on && !booking.child_booking">

                    </div>
                    <div class="col-md-2">
                        <div class="p-4 mb-0 bg-white rounded-lg" v-if="role !== roleUser">
                            <div v-if="booking.booking_type == 2 || booking.is_recurring == 1">
                                <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                    <div class="h3 mb-0">External driver</div>
                                    <a @click="isEditingExternalDriver= !isEditingStatus"
                                       v-if="!isEditingExternalDriver && canEdit">
                                        <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                    </a>
                                    <a class="cursor-pointer" v-if="isEditingExternalDriver"
                                       @click="isEditingExternalDriver = false">
                                        <small>cancel editing</small>
                                    </a>
                                </div>
                                <div v-if="isEditingExternalDriver">
                                    <div class="form-group">
                                        <div class="align-items-center bg-white rounded-lg div-focus">
                                            <v-select
                                                :options="driverList"
                                                v-model="booking.driver"
                                                :clearSearchOnSelect="false"
                                                label="name"
                                                id="driver-name">
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="form-group">
                                        <div>
                                            <span>Driver: </span> <span class="font-weight-semi-bold">{{

                                                booking.driver ? booking.driver.name : ''
                                            }} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="role !== roleUser"
                                 class="btn btn-success mt-3"
                                 @click="changeBookingTypeModal">
                                <i title="Change booking type"></i> Change booking type
                            </div>
                            <div v-if="role !== roleUser"
                                 class="btn btn-success mt-3"
                                 @click="toggleModalCopyBooking"
                            >
                                Copy booking
                            </div>
                            <div class="mt-3" v-if="booking.copies && booking.copies.length">
                                <div class="h3 mb-0">Copies:</div>
                                <div v-for="copy in booking.copies">
                                    {{ copy.copy }}:
                                    <a :href="`/bookings/${copy.id}/edit`">
                                        #B-{{ copy.id }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                <div class="h3 mb-0">Status</div>
                                <a @click="isEditingStatus = !isEditingStatus"
                                   v-if="!isEditingStatus && role !== 'user'">
                                    <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                </a>
                                <a class="cursor-pointer" v-if="isEditingStatus" @click="isEditingStatus = false">
                                    <small>cancel editing</small>
                                </a>
                            </div>
                            <div class="form-group">
                                <div v-if="isEditingStatus"
                                     :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingStatus, '': booking.status_id==='' && isSubmit}">
                                    <select required
                                            class="form-control border-0 py-0 shadow-none pr-5"
                                            :disabled="!isEditingStatus"
                                            :class="{view: !isEditingStatus}"
                                            v-model="booking.status_id">
                                        <option value="1">New</option>
                                        <option value="2">Confirmed</option>
                                        <option value="3" v-if="booking.is_booking_pickup_exists===true">Awaiting
                                            pickup
                                        </option>
                                        <option value="5" v-if="booking.is_booking_pickup_exists===true">On pickup
                                        </option>
                                        <option value="6" v-if="booking.is_booking_linehaul_exists===true">Awaiting
                                            linehaul
                                        </option>
                                        <option value="7" v-if="booking.is_booking_dropoff_exists===true">Ready for
                                            delivery
                                        </option>
                                        <option value="9" v-if="booking.is_booking_dropoff_exists===true">On dropoff
                                        </option>
                                        <option value="10">Delivered</option>
                                    </select>
                                </div>
                                <div v-else class="font-weight-semi-bold">
                                    {{ booking.status }}
                                </div>
                            </div>
                        </div>
                        <div class="p-4 mt-2 mb-0 bg-white rounded-lg" v-if="!booking.is_delivery_from_warehouse && role !== 'user'">
                            <div class="h3 mb-1">Send SMS</div>
                            <div class="dropdown">
                                <button type="button" class="btn btn-primary btn-dropdown"
                                        id="dropdownSendEmail" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                    SMS type
                                    <span class="vertical-align-middle pr-2 material-icons-outlined">sms</span>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownSendEmail">
                                    <span class="dropdown-item cursor-pointer" v-for="smsTemplate in smsTemplates"
                                       @click="smsSend(smsTemplate)">
                                        {{ smsTemplate.title }}
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div v-if="!booking.dropoff_address.phone"
                                     class="d-flex align-items-top justify-content-between mt-1"
                                >
                                    <span class="material-symbols-outlined text-primary">warning</span>
                                    <span>&nbsp;Phone is missing in the delivery address.</span>
                                </div>
                                <div v-if="!booking.dropoff_date || booking.dropoff_date === '0000-00-00'"
                                     class="d-flex align-items-top justify-content-between mt-1"
                                >
                                    <span class="material-symbols-outlined text-primary">warning</span>
                                    <span>&nbsp;Delivery date is invalid</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div v-for="(errorArray, idx) in validationErrors" :key="idx">
                        <div v-for="(allErrors, idx) in errorArray" :key="idx">
                            <span class="text-danger">{{ allErrors }} </span> <br/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid bg-light py-3">
                <div class="row">

                    <div class="col-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Pickup Address</div>
                                        <div>
                                            <a class="d-flex align-items-center text-decoration-none"
                                               @click="isEditingPickup = !isEditingPickup; setHourRange(booking.pickup_date, 'Pickup');"
                                               v-if="!isEditingPickup && !booking.deleted_at && canEdit">
                                                <span
                                                    class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                            </a>
                                            <a v-if="isEditingPickup" @click="isEditingPickup = false"
                                               class="text-decoration-none text-decoration-none">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="pt-3">
                                        <div v-if="isEditingPickup">
                                            <div v-if="postConfirmLocked" class="alert alert-secondary py-1 px-2">
                                                <small>Confirmed booking — change pickup details and services in <a href="#booking-upgrade">Upgrade</a> below.</small>
                                            </div>
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Name</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.name==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_address.name"
                                                           :disabled="!isEditingPickup || postConfirmLocked"
                                                           :class="{view: !isEditingPickup}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Address</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.street==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_address.street"
                                                           :disabled="!isEditingPickup || postConfirmLocked"
                                                           :class="{view: !isEditingPickup}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <div class="form-group row">
                                                    <div class="col-md-4">
                                                        <label class="d-block mb-0 font-weight-bold">Zip</label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.zip==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="booking.pickup_address.zip"
                                                                   :disabled="!isEditingPickup || postConfirmLocked"
                                                                   :class="{view: !isEditingPickup}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <label class="d-block mb-0 font-weight-bold">City</label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.city==='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="booking.pickup_address.city"
                                                                   :disabled="!isEditingPickup || postConfirmLocked"
                                                                   :class="{view: !isEditingPickup}">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Country</label>
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                    <select class="form-control"
                                                            :disabled="postConfirmLocked"
                                                            v-model="booking.pickup_address.country_id">
                                                        <option v-for="item in countryList" :value="item.id">
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Phone</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.phone==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="phone"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_address.phone"
                                                           :disabled="!isEditingPickup || postConfirmLocked"
                                                           :class="{view: !isEditingPickup}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Email</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="email"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_email"
                                                           :disabled="!isEditingPickup || postConfirmLocked"
                                                           :class="{view: !isEditingPickup}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Date</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_date==='' && isSubmit}">
                                                    <date-picker
                                                        v-model="booking.pickup_date"
                                                        valueType="YYYY-MM-DD"
                                                        format="MM/DD/YYYY"
                                                        :disabled="!isEditingPickup || postConfirmLocked"
                                                        :input-class="{'form-control border-0 py-0 shadow-none form-input short-input': true, 'view': !isEditingPickup}"
                                                        :clearable="false"
                                                        :lang="datePickerOptions.lang"
                                                        style="width: 100%;"
                                                        :get-classes="getClassesPickup"
                                                        @input="onSelectDatePickup"
                                                    ></date-picker>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="pickup-start">
                                                        Time start
                                                    </label>
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickup_start==='' && isSubmit? '':''"
                                                        ref="PickupStartTime">
                                                        <vue-timepicker
                                                            hide-clear-button
                                                            manual-input
                                                            placeholder="Start"
                                                            v-model="booking.pickup_start"
                                                            :disabled="postConfirmLocked"
                                                            input-class="border-0 py-0 shadow-none form-input short-input">
                                                        </vue-timepicker>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="pickup-end">
                                                        Time end
                                                    </label>
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickup_end==='' && isSubmit? '':''"
                                                        ref="PickupEndTime"
                                                    >
                                                        <vue-timepicker
                                                            manual-input
                                                            hide-clear-button
                                                            placeholder="End"
                                                            v-model="booking.pickup_end"
                                                            :disabled="postConfirmLocked"
                                                            input-class="border-0 py-0 shadow-none form-input short-input">
                                                        </vue-timepicker>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="pickup-delivered-start">
                                                        Delivered start
                                                    </label>
                                                    <div>
                                                        {{ booking.pickup_delivered_start }}
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="pickup-delivered-end">
                                                        Delivered end
                                                    </label>
                                                    <div>
                                                        {{ booking.pickup_delivered_end }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Note</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_note==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="note"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_note"
                                                           :disabled="!isEditingPickup"
                                                           :class="{view: !isEditingPickup}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            {{ booking.pickup_address.name }} <br>
                                            {{ booking.pickup_address.street }},
                                            {{ booking.pickup_address.zip }}
                                            {{ booking.pickup_address.city }},
                                            {{
                                            booking.pickup_address.country ? booking.pickup_address.country.name :
                                            'Denmark'
                                            }}
                                            <br>
                                            {{ booking.pickup_address.phone }} <br>
                                            {{ booking.pickup_email }} <br>
                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="material-icons-outlined small cursor-pointer pr-1">event</span>
                                                <span>{{ formatDate(booking.pickup_date) }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="material-icons-outlined cursor-pointer pr-1">schedule</span>
                                                <span>{{ booking.pickup_start }} - {{ booking.pickup_end }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span class="material-symbols-outlined pr-1">local_shipping</span>
                                                <span>
                                                    {{ booking.pickup_delivered_start }} -
                                                    {{ booking.pickup_delivered_end }}
                                                </span>
                                            </div>
                                            {{ booking.pickup_note }}
                                        </div>
                                        <br>
                                        <br>
                                        <div class="custom-control custom-checkbox mb-3"
                                             v-if="hasSpecialPermission('can_edit_time_communicated') && booking.pickup_trip">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="pickup_time_communicated"
                                                   v-model="booking.pickup_trip.time_communicated">
                                            <label class="custom-control-label" for="pickup_time_communicated">
                                                <b>Time communicated:</b>
                                            </label>
                                        </div>

                                        <div v-if="booking.services_data.length>0 && (!isEditingPickup || postConfirmLocked)">
                                            <label class="d-block mb-0 font-weight-bold">Services:</label>
                                            <div v-for="service in booking.services_data" v-if="service.type === tripTypePickup">
                                                <div>
                                                    <label class="newInput">
                                                        {{ service.name }}
                                                        <input type="checkbox" checked disabled>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isEditingPickup && !postConfirmLocked">
                                            <label class="d-block mb-0 font-weight-bold">Services:</label>

                                            <div v-for="item in services"
                                                 v-if="item.service.deleted_at===null && item.service.type === tripTypePickup">
                                                <label class="newInput">
                                                    {{ item.service.name }}
                                                    <input type="checkbox"
                                                           name="serviceIds"
                                                           :value="item.service.id"
                                                           :checked="serviceIds.includes(item.service.id)"
                                                           @change="onChangeServiceId($event)"
                                                    >
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <label class="d-block mb-0 font-weight-bold mt-3">Add-ons:</label>
                                        <div class="align-items-center bg-white border rounded-lg div-focus border-2"
                                             v-if="isEditingPickup"
                                        >
                                            <v-select
                                                :options="agreementAddOnsPickup"
                                                v-model="selectedAddOnsPickup"
                                                label="name"
                                                :multiple=true
                                                @input="onSelectAddOn(tripTypePickup)"
                                            >
                                            </v-select>
                                        </div>
                                        <div v-else>
                                            <div v-for="addOn in selectedAddOnsPickup">
                                                <label class="newInput">
                                                    <span>{{ addOn.name }}</span>
                                                    <span v-if="addOn.selected_option">
                                                                    ({{ addOn.selected_option }})
                                                                </span>
                                                    <input type="checkbox" checked disabled>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div v-if="showShorterIntervalOptionsPickup && isEditingPickup">
                                            <div class="font-weight-bold">Kortere tidsinterval pickup</div>
                                            <v-select
                                                :options="shorterIntervalOptionsPickup"
                                                label="option"
                                                v-model="selectedAddOnOptions[addOnShorterIntervalPickup]"
                                                @input="onSelectAddOnOption(addOnShorterIntervalPickup, tripTypePickup)"
                                            >
                                            </v-select>
                                        </div>

                                        <div class="pt-3" v-if="canEditPrices">
                                            <label class="newInput">
                                                <strong>Exclude pickup from Drivers cost report</strong>
                                                <input type="checkbox"
                                                       v-model="excludeFromDriverCostReport.pickup"
                                                       @change="onChangeExcludeFromDriverCostReport('pickup')"
                                                >
                                                <span class="checkmark"></span>
                                            </label>
                                            <div
                                                v-if="excludeFromDriverCostReport.pickup"
                                                class="driver-cost-exclusion-note mt-2"
                                                data-testid="driver-cost-exclusion-note-pickup"
                                            >
                                                <div class="driver-cost-exclusion-note__content">
                                                    <strong>Reason:</strong>
                                                    <span class="driver-cost-exclusion-note__text">{{ booking.pickup_driver_cost_report_exclusion_note || 'Reason is required before saving.' }}</span>
                                                </div>
                                                <button
                                                    type="button"
                                                    class="btn btn-link btn-sm p-0"
                                                    data-testid="edit-driver-cost-exclusion-note-pickup"
                                                    @click="openDriverCostExclusionNoteModal('edit', 'pickup')"
                                                >
                                                    Edit reason
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Delivery Address</div>
                                        <div>
                                            <a class="d-flex align-items-center text-decoration-none"
                                               @click="isEditingDropoff = !isEditingDropoff; previousDropoffDate = booking.dropoff_date; setHourRange(booking.dropoff_date, 'Dropoff');"
                                               v-if="!isEditingDropoff && !booking.deleted_at && canEdit">
                                                <span
                                                    class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                            </a>
                                            <a v-if="isEditingDropoff" @click="isEditingDropoff = false"
                                               class="text-decoration-none">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="pt-3">

                                        <div v-if="isEditingDropoff">
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Name</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.name==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_address.name"
                                                           :disabled="!isEditingDropoff || postConfirmLocked"
                                                           :class="{view: !isEditingDropoff}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Address</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.street==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_address.street"
                                                           :disabled="!isEditingDropoff || postConfirmLocked"
                                                           :class="{view: !isEditingDropoff}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <div class="form-group row">
                                                    <div class="col-md-4">
                                                        <label class="d-block mb-0 font-weight-bold">Zip</label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.zip==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="booking.dropoff_address.zip"
                                                                   :disabled="!isEditingDropoff || postConfirmLocked"
                                                                   :class="{view: !isEditingDropoff}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <label class="d-block mb-0 font-weight-bold">City</label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.city==='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="booking.dropoff_address.city"
                                                                   :disabled="!isEditingDropoff || postConfirmLocked"
                                                                   :class="{view: !isEditingDropoff}">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Country</label>
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                    <select class="form-control"
                                                            :disabled="postConfirmLocked"
                                                            v-model="booking.dropoff_address.country_id">
                                                        <option v-for="item in countryList" :value="item.id">
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Phone</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.phone==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="phone"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_address.phone"
                                                           :disabled="!isEditingDropoff || postConfirmLocked"
                                                           :class="{view: !isEditingDropoff}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Email</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="email"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_email"
                                                           :disabled="!isEditingDropoff || postConfirmLocked"
                                                           :class="{view: !isEditingDropoff}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div v-if="postConfirmLocked" class="alert alert-secondary py-1 px-2">
                                                <small>Confirmed booking — change delivery details and services in <a href="#booking-upgrade">Upgrade</a> below.</small>
                                            </div>
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Date</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_date==='' && isSubmit}">
                                                    <date-picker
                                                        v-model="booking.dropoff_date"
                                                        valueType="YYYY-MM-DD"
                                                        format="MM/DD/YYYY"
                                                        @change="handleDropoffDateChange"
                                                        :disabled="!isEditingDropoff || !hasSpecialPermission('can_change_dropoff_date') || postConfirmLocked"
                                                        :input-class="{'form-control border-0 py-0 shadow-none form-input short-input': true, 'view': !isEditingDropoff}"
                                                        :clearable="false"
                                                        :lang="datePickerOptions.lang"
                                                        style="width: 100%;"
                                                        :get-classes="getClassesDropoff"
                                                        @input="onSelectDateDropoff"
                                                    ></date-picker>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="dropoff-start">
                                                        Time start
                                                    </label>
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.dropoff_start==='' && isSubmit? '':''"
                                                        ref="DropoffStartTime"
                                                    >
                                                        <vue-timepicker
                                                            manual-input
                                                            hide-clear-button
                                                            placeholder="Start"
                                                            v-model="booking.dropoff_start"
                                                            :disabled="postConfirmLocked"
                                                            input-class="border-0 py-0 shadow-none form-input short-input">
                                                        </vue-timepicker>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="dropoff-end">
                                                        Time end
                                                    </label>
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.dropoff_end==='' && isSubmit? '':''"
                                                        ref="DropoffEndTime"
                                                    >
                                                        <vue-timepicker
                                                            manual-input
                                                            hide-clear-button
                                                            placeholder="End"
                                                            v-model="booking.dropoff_end"
                                                            :disabled="postConfirmLocked"
                                                            input-class="border-0 py-0 shadow-none form-input short-input">
                                                        </vue-timepicker>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="dropoff-delivered-start">
                                                        Delivered start
                                                    </label>
                                                    <div>
                                                        {{ booking.dropoff_delivered_start }}
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="dropoff-delivered-end">
                                                        Delivered end
                                                    </label>
                                                    <div>
                                                        {{ booking.dropoff_delivered_end }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Note</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_note==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="note"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_note"
                                                           :disabled="!isEditingDropoff"
                                                           :class="{view: !isEditingDropoff}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            {{ booking.dropoff_address.name }} <br>
                                            {{ booking.dropoff_address.street }},
                                            {{ booking.dropoff_address.zip }}
                                            {{ booking.dropoff_address.city }},

                                            {{

                                            booking.dropoff_address.country ? booking.dropoff_address.country.name :
                                            'Denmark'
                                            }}

                                            <br>
                                            {{ booking.dropoff_address.phone }} <br>
                                            {{ booking.dropoff_email }} <br>

                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="material-icons-outlined small cursor-pointer pr-1">event</span>
                                                <span>{{ formatDate(booking.dropoff_date) }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="material-icons-outlined cursor-pointer pr-1">schedule</span>
                                                <span>{{ booking.dropoff_start }} - {{ booking.dropoff_end }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span class="material-symbols-outlined pr-1">local_shipping</span>
                                                <span>
                                                    {{ booking.dropoff_delivered_start }} -
                                                    {{ booking.dropoff_delivered_end }}
                                                </span>
                                            </div>
                                            {{ booking.dropoff_note }}
                                        </div>
                                        <br/>
                                        <br/>
                                        <div class="custom-control custom-checkbox mb-3"
                                             v-if="hasSpecialPermission('can_edit_time_communicated') && booking.dropoff_trip">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="dropoff_time_communicated"
                                                   v-model="booking.dropoff_trip.time_communicated">
                                            <label class="custom-control-label" for="dropoff_time_communicated">
                                                <b>Time communicated:</b>
                                            </label>
                                        </div>
                                        <div class="custom-control custom-checkbox mb-3">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="is_delivery_from_warehouse"
                                                   v-model="booking.is_delivery_from_warehouse">
                                            <label class="custom-control-label" for="is_delivery_from_warehouse">
                                                <b>Delivery from warehouse:</b></label>
                                        </div>

                                        <div v-if="booking.services_data.length>0 && (!isEditingDropoff || postConfirmLocked)">
                                            <label class="d-block mb-0 font-weight-bold">Services:</label>
                                            <div v-for="service in booking.services_data" v-if="service.type === tripTypeDropoff">
                                                <div>
                                                    <label class="newInput">
                                                        {{ service.name }}
                                                        <input type="checkbox" checked disabled>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isEditingDropoff && !postConfirmLocked">
                                            <label class="d-block mb-0 font-weight-bold">Services:</label>

                                            <div v-for="item in services"
                                                 v-if="item.service.deleted_at===null && item.service.type === tripTypeDropoff">
                                                <label class="newInput">
                                                    {{ item.service.name }}
                                                    <input type="checkbox"
                                                           name="serviceIds"
                                                           :value="item.service.id"
                                                           :checked="serviceIds.includes(item.service.id)"
                                                           @change="onChangeServiceId($event)"
                                                    >
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <label class="d-block mb-0 font-weight-bold mt-3">Add-ons:</label>
                                        <div class="align-items-center bg-white border rounded-lg div-focus border-2"
                                             v-if="isEditingDropoff"
                                        >
                                            <v-select
                                                :options="agreementAddOnsDropoff"
                                                v-model="selectedAddOnsDropoff"
                                                label="name"
                                                :multiple=true
                                                :disabled="postConfirmLocked"
                                                @input="onSelectAddOn(tripTypeDropoff)"
                                            >
                                            </v-select>
                                        </div>
                                        <div v-else>
                                            <div v-for="addOn in selectedAddOnsDropoff">
                                                <label class="newInput">
                                                    <span>{{ addOn.name }}</span>
                                                    <span v-if="addOn.selected_option">
                                                                    ({{ addOn.selected_option }})
                                                                </span>
                                                    <input type="checkbox" checked disabled>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div v-if="showShorterIntervalOptionsDropoff && isEditingDropoff">
                                            <div class="font-weight-bold">Kortere tidsinterval dropoff</div>
                                            <v-select
                                                :options="shorterIntervalOptionsDropoff"
                                                label="option"
                                                v-model="selectedAddOnOptions[addOnShorterIntervalDropoff]"
                                                :disabled="postConfirmLocked"
                                                @input="onSelectAddOnOption(addOnShorterIntervalDropoff, tripTypeDropoff)"
                                            >
                                            </v-select>
                                        </div>

                                        <div class="pt-3" v-if="canEditPrices">
                                            <label class="newInput">
                                                <strong>Exclude dropoff from Drivers cost report</strong>
                                                <input type="checkbox"
                                                       v-model="excludeFromDriverCostReport.dropoff"
                                                       @change="onChangeExcludeFromDriverCostReport('dropoff')"
                                                >
                                                <span class="checkmark"></span>
                                            </label>
                                            <div
                                                v-if="excludeFromDriverCostReport.dropoff"
                                                class="driver-cost-exclusion-note mt-2"
                                                data-testid="driver-cost-exclusion-note-dropoff"
                                            >
                                                <div class="driver-cost-exclusion-note__content">
                                                    <strong>Reason:</strong>
                                                    <span class="driver-cost-exclusion-note__text">{{ booking.dropoff_driver_cost_report_exclusion_note || 'Reason is required before saving.' }}</span>
                                                </div>
                                                <button
                                                    type="button"
                                                    class="btn btn-link btn-sm p-0"
                                                    data-testid="edit-driver-cost-exclusion-note-dropoff"
                                                    @click="openDriverCostExclusionNoteModal('edit', 'dropoff')"
                                                >
                                                    Edit reason
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Rekv. number</div>
                                        <div>
                                            <a @click="isEditingNote = !isEditingNote"
                                               v-if="!isEditingNote && !booking.deleted_at && canEdit">
                                                <span
                                                    class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                            </a>
                                            <a v-if="isEditingNote" @click="isEditingNote = false">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>

                                    </div>
                                    <div class="pt-3">
                                        <div class="form-group" v-if="booking.note && !isEditingNote">
                                            <label class="d-block mb-0 font-weight-bold">Note:</label>
                                            <div>
                                                {{ booking.note }}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="d-block mb-0 font-weight-bold">Reference:</label>
                                            <div v-if="!isEditingNote">
                                                {{ booking.reference }}
                                            </div>
                                            <div v-else
                                                 :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingNote, 'border-danger': booking.reference==='' && isSubmit}">
                                                <input type="text"
                                                       autocomplete="off"
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="reference"
                                                       v-model="booking.reference" :disabled="!isEditingNote"
                                                       :class="{view: !isEditingNote}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>

                                        <div class="form-group" v-if="bookingPermits.length">
                                            <label class="d-block mb-0 font-weight-bold" for="permits">Fuldmagt:</label>
                                            <div v-for="permit in bookingPermits">
                                                {{ permit }}
                                            </div>
<!--                                            <div class="align-items-center bg-white border rounded-lg div-focus" v-else>-->
<!--                                                <v-select-->
<!--                                                    :options="availablePermits"-->
<!--                                                    v-model="booking.customer_options[permitsKey].value"-->
<!--                                                    id="permits"-->
<!--                                                >-->
<!--                                                </v-select>-->
<!--                                                <div class="help-block with-errors"></div>-->
<!--                                            </div>-->
                                        </div>

                                        <div class="form-group">
                                            <div v-if="booking.pickup_trip && booking.pickup_trip.image">
                                                <div v-for="(image, index) in getImageArray(booking.pickup_trip.image)"
                                                     :key="index"
                                                     class="d-flex justify-content-between"><span>Pickup trip PoD:</span>
                                                    <div>
                                                        <a class="btn btn-info btn-sm pod-button"
                                                           @click="downloadPod(image, booking.pickup_trip.id, fileTypeImage, index)">
                                                            Download PoD
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="booking.pickup_trip && booking.pickup_trip.signature"
                                                 class="d-flex justify-content-between"><span>Pickup trip PoD:</span>
                                                <div><a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadPod(booking.pickup_trip.signature, booking.pickup_trip.id, fileTypeSignature)">
                                                    Download PoD
                                                </a>
                                                </div>
                                            </div>
                                            <div v-if="booking.pickup_trip && booking.pickup_trip.signature && booking.pickup_trip.image"
                                                 class="d-flex justify-content-between"><span>Pickup trip complete PoD:</span>
                                                <!-- @todo downloadCompletePod   -->
                                                <div><a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadCompletePod(booking.pickup_trip.id)">
                                                    Download PoD
                                                </a>
                                                </div>
                                            </div>
                                            <div v-if="booking.dropoff_trip && booking.dropoff_trip.image">
                                                <div v-for="(image, index) in getImageArray(booking.dropoff_trip.image)"
                                                     :key="index"
                                                     class="d-flex justify-content-between"><span>Dropoff trip PoD:</span>
                                                    <div>
                                                        <a class="btn btn-info btn-sm pod-button"
                                                           @click="downloadPod(image, booking.dropoff_trip.id, fileTypeImage, index)">
                                                            Download PoD
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="booking.dropoff_trip &&  booking.dropoff_trip.signature"
                                                 class="d-flex justify-content-between"><span>Dropoff trip PoD:</span>
                                                <div><a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadPod(booking.dropoff_trip.signature, booking.dropoff_trip.id,fileTypeSignature)">
                                                    Download PoD
                                                </a>
                                                </div>
                                            </div>
                                            <div v-if="booking.dropoff_trip && booking.dropoff_trip.signature && booking.dropoff_trip.image"
                                                 class="d-flex justify-content-between"><span>Dropoff trip complete PoD:</span>
                                                <div><a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadCompletePod(booking.dropoff_trip.id)">
                                                    Download PoD
                                                </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg"
                                     :class="booking.status_id===1 && (booking.product_price==='' || booking.product_price===0)? 'border border-danger border-width-3':''"
                                >
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Colli</div>
                                    </div>
                                    <div class="pt-3">
                                        <b> Total Volume (m3)</b> <br/>
                                        <div class="form-group">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                <input type="text"
                                                       autocomplete="off"
                                                       required
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="volume"
                                                       v-model="booking.volume"
                                                       :disabled=true
                                                       :class="{view: !isEditingColli}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <b> Total Weight (kg)</b> <br/>
                                        <div class="form-group">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.weight==='' && isSubmit}">
                                                <input type="text"
                                                       autocomplete="off"
                                                       required
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="weight"
                                                       v-model="booking.weight"
                                                       :disabled=true
                                                       :class="{view: !isEditingColli}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <b> Total Colli (m3)</b> <br/>
                                        <div class="form-group">

                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.colli==='' && isSubmit}">
                                                <input type="text"
                                                       autocomplete="off"
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="colli"
                                                       v-model="booking.colli"
                                                       :disabled=true
                                                       :class="{view: !isEditingColli}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="container-fluid bg-light py-3">
                <div class="row">

                    <div class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Trip info</div>
                                        <div>
                                            <a class="d-flex align-items-center text-decoration-none"
                                               @click="isEditingTrip = !isEditingTrip"
                                               v-if="!isEditingTrip && !booking.deleted_at && canEdit">
                                                <span
                                                    class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                            </a>
                                            <a v-if="isEditingTrip" @click="isEditingTrip = false"
                                               class="text-decoration-none">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="container-fluid py-3 bg-white">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <label class="d-block mb-0 font-weight-bold">Products:</label>
                                                    <div>
                                                        <label class="newInput">
                                                            {{ booking.product ? booking.product.name : 'Product not found' }}
                                                            <input type="checkbox" checked disabled>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>

                                                    <label class="d-block mb-0 font-weight-bold">Linehaul:</label>
                                                    <div v-if="!isEditingTrip">
                                                        <div>
                                                            <label class="newInput">
                                                                {{ getLinehaulTypeLabel(booking.linehaul_type) }}
                                                                <input type="checkbox" checked disabled>
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <span class="form-control-plaintext">
                                                            {{ getLinehaulTypeLabel(booking.linehaul_type) }}
                                                        </span>
                                                    </div>

                                                    <div class="form-group" v-if="role !== 'user'">
                                                        <label class="d-block mb-0 font-weight-bold">
                                                            Internal comment:
                                                        </label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingTrip, 'border-danger': booking.internal_comment==='' && isSubmit}">
                                                           <textarea
                                                               rows="7"
                                                               class="form-control form-control border-1 py-0 shadow-none form-input"
                                                               :class="{view: !isEditingTrip}"
                                                               :disabled="!isEditingTrip"
                                                               v-model="booking.internal_comment"
                                                               placeholder="">
                                                           </textarea>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="col-md-9">
                                                    <ul class="nav nav-tabs border d-inline-flex">
                                                        <li v-if="booking.pickup_trip">
                                                            <a data-toggle="tab" href="#pickup_tab"
                                                               class="btn btn-sm btn-white py-2 px-3"
                                                               :class="booking.status_id!==10 ? 'active' : ''">
                                                                Pick Up
                                                            </a>
                                                        </li>
                                                        <li v-if="booking.linehaul_trip"
                                                            class="border-left border-right">
                                                            <a data-toggle="tab" href="#linehaul_tab"
                                                               class="btn btn-sm btn-white py-2 px-3"
                                                               :class="booking.status_id===10 ? 'active' : ''">
                                                                LineHaul &nbsp;
                                                            </a>
                                                        </li>
                                                        <li v-if="booking.dropoff_trip">
                                                            <a data-toggle="tab" href="#dropoff_tab"
                                                               class="btn btn-sm btn-white py-2 px-3"
                                                               :class="(booking.status_id===10 && !booking.linehaul_trip) ||  (!booking.pickup_trip  && !booking.linehaul_trip)  ? 'active' : ''">
                                                                Drop-off
                                                            </a>
                                                        </li>
                                                    </ul>

                                                    <div class="tab-content pt-3">
                                                        <div id="pickup_tab"
                                                             class="tab-pane fade"
                                                             :class="booking.status_id!==10 ? 'active show' : ''"
                                                             v-if="booking.pickup_trip">
                                                            <div class="timeline">
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=0 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label class="mb-0 font-weight-semi-bold">Awaiting
                                                                            date</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">New</label>
                                                                    </div>
                                                                </div>
                                                                <div v-if="tripCanBeMarkedAsForeign(booking.pickup_trip, booking.pickup_address)"
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status==11 || booking.pickup_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Foreign</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=2 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Transferred</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=3 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Scheduled</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=4 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Servicing</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=5 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Failed</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=6 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Rejected</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=7 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Delivered</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="">
                                                                <div style="display:inline-block;" class="ml-3">
                                                                    <a v-if="role !== 'user'"
                                                                       :href="`/trips/${booking.pickup_trip.id}/edit`"
                                                                       class="btn btn-primary">View trip</a>
                                                                </div>
                                                                <div style="display:inline-block;"
                                                                     class="btn btn-success ml-3"
                                                                     @click="setTripDelivered(booking.pickup_trip.id, 1)">
                                                                    <i title="mark delivered"></i> Mark delivered
                                                                </div>
                                                                <div style="display:inline-block;"
                                                                     v-if="booking.pickup_trip.status === 5"
                                                                     class="btn btn-danger ml-3 mr-3"
                                                                     @click="setTripRejected(booking.pickup_trip.id, deliveredDate.pickupDate)">

                                                                    <i title="mark rejected"></i> Mark rejected
                                                                </div>
                                                                <div v-if="false && booking.pickup_trip.tw_start===null"
                                                                     class="trip-actions">
                                                                    <!-- hidden as https://app.asana.com/1/938290244899/task/1210064868430051/comment/1210094793044279?focus=true -->
                                                                    <div
                                                                        class="bg-white border- rounded-lg div-focus border-2">
                                                                        <date-picker
                                                                            manual-input
                                                                            v-model="deliveredDate.pickupDate"
                                                                            valueType="format"
                                                                            input-class="border-0 py-0 shadow-none form-input"
                                                                            placeholder="DD-MM-YYYY"
                                                                            :lang="datePickerOptions.lang"
                                                                            format="DD-MM-YYYY">
                                                                        </date-picker>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div id="linehaul_tab"
                                                             class="tab-pane fade"
                                                             :class="booking.status_id===10 ? 'active show' : ''"
                                                             v-if="booking.linehaul_trip">
                                                            <div class="timeline">
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">New</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=2 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Transferred</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=3 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Scheduled</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=4 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Servicing</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=5 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Failed</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=6 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Rejected</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=7 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Delivered</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <a v-if="role !== 'user'"
                                                               :href="`/trips/${booking.linehaul_trip.id}/edit`"
                                                               class="btn btn-primary ml-3">View trip</a>

                                                            <div class="btn btn-success ml-3"
                                                                 @click="setTripDelivered(booking.linehaul_trip.id, 2)">
                                                                <i title="mark delivered"></i>Mark delivered
                                                            </div>
                                                            <div v-if="booking.linehaul_trip.status === 5"
                                                                 class="btn btn-danger ml-3"
                                                                 @click="setTripRejected(booking.linehaul_trip.id)">
                                                                <i title="mark rejected"></i> Mark rejected
                                                            </div>

                                                        </div>
                                                        <div id="dropoff_tab"
                                                             class="tab-pane fade"
                                                             :class="(booking.status_id===10 && !booking.linehaul_trip) ||  (!booking.pickup_trip  && !booking.linehaul_trip)  ? 'active show' : ''"
                                                             v-if="booking.dropoff_trip">
                                                            <div class="timeline">
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=0 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label class="mb-0 font-weight-semi-bold">Awaiting
                                                                            date</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">New</label>
                                                                    </div>
                                                                </div>
                                                                <div v-if="tripCanBeMarkedAsForeign(booking.dropoff_trip, booking.dropoff_address)"
                                                                     class="container-time  time-right"
                                                                     :class="booking.dropoff_trip.status==11 || booking.dropoff_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Foreign</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=2 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Transferred</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=3 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Scheduled</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=4 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Servicing</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=5 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Failed</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=6 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Rejected</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=7 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Delivered</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <a v-if="role !== 'user'"
                                                               :href="`/trips/${booking.dropoff_trip.id}/edit`"
                                                               class="btn btn-primary ml-3">View trip
                                                            </a>
                                                            <div class="btn btn-success ml-3"
                                                                 @click="setTripDelivered(booking.dropoff_trip.id, 3)">
                                                                <i title="mark delivered"></i> Mark delivered
                                                            </div>
                                                            <div v-if="booking.dropoff_trip.status === 5"
                                                                 class="btn btn-danger ml-3 mr-3"
                                                                 @click="setTripRejected(booking.dropoff_trip.id)">
                                                                <i title="mark rejected"></i> Mark rejected
                                                            </div>
                                                            <div v-if="booking.dropoff_trip.tw_start===null"
                                                                 class="trip-actions">
                                                                <div
                                                                    class="bg-white border- rounded-lg div-focus border-2">
                                                                    <date-picker
                                                                        manual-input
                                                                        v-model="deliveredDate.dropoffDate"
                                                                        valueType="format"
                                                                        input-class="border-0 py-0 shadow-none form-input"
                                                                        placeholder="date"
                                                                        :lang="datePickerOptions.lang"
                                                                        format="DD-MM-YYYY">
                                                                    </date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-4" v-if="booking.type === typeAdHoc">
                                                <div class="col-md-12">
                                                    <div class="font-weight-bold">Custom services</div>
                                                    <div v-if="isEditingTrip">
                                                        <div v-for="(bookingCustomService, k) in booking.customServices"
                                                             class="d-flex justify-content-between align-items-center mb-1"
                                                        >
                                                            <div class="align-items-center bg-white border rounded-lg div-focus border-2 mr-1"
                                                                 style="width: 90%; height: 100%"
                                                            >
                                                                <v-select
                                                                    :options="customServices"
                                                                    v-model="booking.customServices[k]['name']"
                                                                >
                                                                </v-select>
                                                            </div>
                                                            <div class="float-right"
                                                                 title="Remove"
                                                                 @click="deleteCustomService(k)">
                                                                <div class="material-icons-outlined cursor-pointer text-primary"
                                                                     title="delete product">delete
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mt-3">
                                                            <div class="font-weight-bold">
                                                                Select a custom service
                                                            </div>
                                                            <div>
                                                                <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                                    <v-select
                                                                        :options="customServices"
                                                                        v-model="selectedCustomService"
                                                                    >
                                                                    </v-select>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-success mt-2"
                                                                    @click="addNewCustomService(selectedCustomService)"
                                                                >Add</button>
                                                            </div>
                                                            <div class="mt-3">
                                                                <div class="font-weight-bold">
                                                                    Add a new custom service
                                                                </div>
                                                                <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                                           v-model="newCustomService"
                                                                           :class="{view: true}">
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-success mt-2"
                                                                    @click="addNewCustomService(newCustomService)"
                                                                >Add</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div v-for="(bookingCustomService, k) in booking.customServices">
                                                            {{ bookingCustomService.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg"
                                     v-if="canViewPrices"
                                     :class="booking.status_id===1 && (booking.product_price==='' || booking.product_price===0)?'border border-danger border-width-3':''"
                                >
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Price</div>
                                        <span class="edit-product"></span>
                                        <div>
                                    <span
                                        @click="scrollToElement({behavior: 'smooth'},'edit-product');isEditingProduct = !isEditingProduct;"
                                        v-if="!isEditingProduct  && !booking.deleted_at && canEdit && canEditPrices"
                                        class="text-decoration-none">
                                        <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                    </span>
                                            <a href="#" v-if="isEditingProduct" @click="isEditingProduct = false"
                                               class="text-decoration-none">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="table-responsive">
                                            <table class="table border" aria-label="table-price">
                                                <thead>
                                                <tr>
                                                    <th scope="col">Product</th>
                                                    <th scope="col" class="text-center">Price</th>
                                                    <th scope="col" class="text-center">Amount</th>
                                                    <th scope="col" class="text-center">Unit</th>
                                                    <th scope="col" class="text-center">Total Price</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td class="text-center"> {{ booking.product ? booking.product.name : 'Product not found' }}</td>
                                                    <td class="text-center">
                                                        <div v-if="booking.product && booking.product.price_type===1">
                                                            <div
                                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': booking.product_price==='' && isSubmit}">
                                                                <input type="text"
                                                                       autocomplete="off"
                                                                       required
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="price"
                                                                       v-model="booking.product_price"
                                                                       :disabled="!isEditingProduct || !canEditPrices"
                                                                       :class="{view: !isEditingProduct}">
                                                                <div class="help-block with-errors"></div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div
                                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': booking.product_price==='' && isSubmit}">
                                                                <input type="text"
                                                                       autocomplete="off"
                                                                       required
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="price"
                                                                       v-model="booking.product_price"
                                                                       :disabled="!isEditingProduct || !canEditPrices"
                                                                       :class="{view: !isEditingProduct}">
                                                                <div class="help-block with-errors"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">

                                                        <div
                                                            v-if="isEditingProduct && booking.product && booking.product.price_type!==1">
                                                            <input type="number" min="0" step="0.1"
                                                                   autocomplete="off"
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="time units"
                                                                   :disabled="!canEditPrices"
                                                                   @change="recalculateTimeUnitsProduct($event, booking.id, booking.product_time_units)"
                                                                   :value="booking.product_time_units">
                                                        </div>
                                                        <div v-else>
                                                            {{
                                                                (booking.product && booking.product.price_type === 1) ? 1 :
                                                            booking.product_time_units
                                                            }}
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <div v-if="booking.product && booking.product.price_type===1">
                                                            pcs
                                                        </div>
                                                        <div v-else-if="booking.product && booking.product.price_type===2">
                                                            hours
                                                        </div>
                                                        <div v-else-if="booking.product && booking.product.price_type===3">
                                                            days
                                                        </div>
                                                        <div v-else-if="booking.product && booking.product.price_type===4">
                                                            weeks
                                                        </div>
                                                        <div v-else-if="booking.product && booking.product.price_type===5">
                                                            months
                                                        </div>
                                                        <div v-else>
                                                            years
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ booking.product_price }}
                                                    </td>
                                                </tr>

                                                <tr v-if="booking.services_data.length>0">
                                                    <th scope="col">Service</th>
                                                    <th scope="col" class="text-center">Price</th>
                                                    <th scope="col" class="text-center">Amount</th>
                                                    <th scope="col" class="text-center">Unit</th>
                                                    <th scope="col" class="text-center">Total Price</th>
                                                </tr>

                                                <tr v-for="service in booking.services_data">
                                                    <td class="text-center"> {{ service.name }}</td>
                                                    <td class="text-center">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': service.price==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="price"
                                                                   v-model="service.price"
                                                                   :disabled="!isEditingProduct || !canEditPrices"
                                                                   :class="{view: !isEditingProduct}">
                                                            <div class="help-block with-errors"></div>
                                                        </div>
                                                    </td>

                                                    <td class="text-center">
                                                        <div
                                                            v-if="isEditingProduct && service.price_type!==1">
                                                            <input type="number" min="0" step="0.1"
                                                                   autocomplete="off"
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="time units"
                                                                   @change="recalculateTimeUnitsService($event, service.id, service.time_unit)"
                                                                   :disabled="!canEditPrices"
                                                                   :value="service.time_unit"
                                                            >
                                                        </div>
                                                        <div v-else>
                                                            <div v-if="service.price_type === 1">
                                                                1
                                                            </div>
                                                            <div v-else>
                                                                {{ service.time_unit }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <div v-if="service.price_type===1">
                                                            pcs
                                                        </div>
                                                        <div v-else-if="service.price_type===2">
                                                            hours
                                                        </div>
                                                        <div v-else-if="service.price_type===3">
                                                            days
                                                        </div>
                                                        <div v-else-if="service.price_type===4">
                                                            weeks
                                                        </div>
                                                        <div v-else-if="service.price_type===5">
                                                            months
                                                        </div>
                                                        <div v-else>
                                                            years
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ service.price }}
                                                    </td>
                                                </tr>

                                                <tr v-if="selectedAddOnsPickup.length || selectedAddOnsDropoff.length">
                                                    <th scope="col">Add-on</th>
                                                    <th scope="col" class="text-center">Price</th>
                                                    <th scope="col" class="text-center">Amount</th>
                                                    <th scope="col" class="text-center">Unit</th>
                                                    <th scope="col" class="text-center">Total Price</th>
                                                </tr>

                                                <tr v-for="addOn in selectedAddOnsPickup">
                                                    <td class="text-center">
                                                        <div>{{ addOn.name }}</div>
                                                        <div v-if="addOn.selected_option">
                                                            {{ addOn.selected_option }}
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': addOn.price==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="price"
                                                                   v-model="addOn.price"
                                                                   :disabled="!isEditingProduct || !canEditPrices"
                                                                   :class="{view: !isEditingProduct}">
                                                        </div>
                                                    </td>

                                                    <td class="text-center">1</td>
                                                    <td class="text-center">
                                                        <div>pcs</div>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ addOn.price }}
                                                    </td>
                                                </tr>

                                                <tr v-for="addOn in selectedAddOnsDropoff">
                                                    <td class="text-center">
                                                        <div>{{ addOn.name }}</div>
                                                        <div v-if="addOn.selected_option">
                                                            {{ addOn.selected_option }}
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': addOn.price==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="price"
                                                                   v-model="addOn.price"
                                                                   :disabled="!isEditingProduct || !canEditPrices"
                                                                   :class="{view: !isEditingProduct}">
                                                        </div>
                                                    </td>

                                                    <td class="text-center">1</td>
                                                    <td class="text-center">
                                                        <div>pcs</div>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ addOn.price }}
                                                    </td>
                                                </tr>

                                                <tr v-if="booking.customServices && booking.customServices.length">
                                                    <th scope="col">Custom service</th>
                                                    <th scope="col" class="text-center">Price</th>
                                                    <th scope="col" class="text-center">Amount</th>
                                                    <th scope="col" class="text-center">Unit</th>
                                                    <th scope="col" class="text-center">Total Price</th>
                                                </tr>

                                                <tr v-for="customService in booking.customServices">
                                                    <td class="text-center"> {{ customService.name }}</td>
                                                    <td class="text-center">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': customService.price==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="price"
                                                                   v-model="customService.price"
                                                                   :disabled="!isEditingProduct || !canEditPrices"
                                                                   :class="{view: !isEditingProduct}">
                                                        </div>
                                                    </td>

                                                    <td class="text-center">1</td>
                                                    <td class="text-center">
                                                        <div>pcs</div>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ customService.price }}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colspan="3"></td>
                                                    <th scope="row" class="white-space-nowrap text-right"> Deadline fee</th>
                                                    <td class="white-space-nowrap text-center">
                                                        <span v-if="parseFloat(booking.deadline_fee) !== 0">-</span>{{ booking.deadline_fee }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <th scope="row" class="white-space-nowrap text-right"> Storage fee</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ booking.storage_fee }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <th scope="row" class="white-space-nowrap text-right"> Total excl. VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVat() }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <th scope="row" class="white-space-nowrap text-right"> VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVat() * vat }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <th scope="row" class="white-space-nowrap text-right">Total incl. VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVat() * (1 + vat) }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="5"></td>
                                                </tr>
                                                <tr v-if="canEditPrices">
                                                    <td class="text-center"> Cost price</td>
                                                    <td class="text-center">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': booking.cost_price==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="price"
                                                                   v-model="booking.cost_price"
                                                                   :disabled="!isEditingProduct || !canEditPrices"
                                                                   :class="{view: !isEditingProduct}">
                                                        </div>
                                                    </td>
                                                    <td class="text-center"></td>
                                                    <td class="text-center"></td>
                                                    <td class="text-center"></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div id="booking-upgrade" class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Upgrade</div>
                                    </div>
                                    <post-confirm-edit-panel
                                        v-if="hasSpecialPermission('can_post_confirm_edit') && booking.id && booking.status_id >= 2"
                                        :options-url="postConfirmOptionsUrl"
                                        :apply-dropoff-url="postConfirmApplyDropoffUrl"
                                        :apply-pickup-url="postConfirmApplyPickupUrl"
                                        :country-list="countryList"
                                    ></post-confirm-edit-panel>
                                    <div class="pt-3" v-for="customerOptions in booking.customerOptions">
                                        <customer-options
                                            :options="customerOptions.options"
                                            :transaction="customerOptions.transaction"
                                            :prime-key="primeKey"
                                            :add-ons-key="addOnsKey"
                                            :payment-statuses="paymentStatuses"
                                        ></customer-options>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <!-- If null booking.logs value comes from controller section will be hidden -->
                                <div
                                    v-if="booking.logs !== null"
                                    class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Logging</div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="table-responsive">
                                            <table class="table table-striped border" aria-label="Logs table">
                                                <thead>
                                                <tr>
                                                    <th>Activity</th>
                                                    <th>Initiated by</th>
                                                    <th>Time</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-if="booking.logs" v-for="log in booking.logs">
                                                    <td>
                                                        <span v-if="[logActionUpdated, logActionAddOnsUpdated, logActionCustomerChangedOptions, logActionCustomServicesUpdated, logActionUpdatedAfterConfirmation].includes(log.action)">
                                                            <a @click.prevent="toggleModalLog(log.id)"
                                                                href="#">{{ log.action }}</a>
                                                        </span>
                                                        <span v-else>
                                                             {{ log.action }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {{
                                                        log.initiated_by !== null ? log.initiated_by : log.user.email
                                                        }}
                                                    </td>
                                                    <td>{{ formatDateTime(log.action_time) }}</td>
                                                </tr>
                                                <tr v-if="!booking.logs">
                                                    <td>Booking created</td>
                                                    <td>Admin</td>
                                                    <td>{{ booking.created_at }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">SMS Logging</div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="table-responsive">
                                            <table class="table table-striped border" aria-label="Sms logs table">
                                                <thead>
                                                <tr>
                                                    <th>Sms type</th>
                                                    <th>Status</th>
                                                    <th>Sent to</th>
                                                    <th>Sent at</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-if="booking.smsLogs"
                                                    v-for="log in booking.smsLogs"
                                                    @click="toggleModalSmsLog(log.id)"
                                                >
                                                    <td>{{ log.title }}</td>
                                                    <td>
                                                        <span>{{ log.status }}</span>
                                                        <span v-if="log.details && log.details.errorCode">
                                                            &nbsp({{ log.details.errorCode }})
                                                        </span>
                                                    </td>
                                                    <td>{{ log.sent_to }}</td>
                                                    <td>{{ formatDateTime(log.sent_at) }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="role !== 'user'" class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div v-if="role !== 'user'" class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Communication</div>
                                    </div>

                                    <div class="pt-3">
                                        <div class="table-responsive">
                                            <table class="table table-striped border">
                                                <thead>
                                                <tr>
                                                    <th>Type</th>
                                                    <th>Initiated by</th>
                                                    <th>Time</th>
                                                    <th>Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="value in communicationLog">
                                                    <td>{{ value.communication_type == 1 ? 'SMS' : 'EMAIL' }}</td>
                                                    <td>Admin</td>
                                                    <td>
                                                        {{
                                                        new Date(value.created_at).toLocaleString('da-DK', {
                                                        year: "numeric",
                                                        month: "2-digit",
                                                        day: "2-digit",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        })
                                                        }}
                                                    </td>
                                                    <td>{{ value.statuss === 'success' ? 'success' : 'not sent' }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid bg-light py-3">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4 box-shadow h-100">
                                    <div class="card-body">
                                        <div class="p-4 mb-0 bg-white rounded-lg">
                                            <div
                                                class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                                <div class="h3 mb-0">Products</div>
                                            </div>
                                            <div class="pt-3">
                                                <div class="table-responsive">
                                                    <table class="table border">
                                                        <tbody>
                                                        <tr>
                                                            <th>Reference</th>
                                                            <th>Name</th>
                                                            <th>Colli</th>
                                                            <th>Volume(m3)</th>
                                                            <th>Weight(kg)</th>
                                                            <th>Location</th>
                                                            <th>
                                                                <a v-if="isEditingColli"
                                                                   @click="isEditingColli = false; booking.colliDataChanged=!booking.colliDataChanged"
                                                                   class="text-decoration-none">
                                                                    <small>cancel editing</small>
                                                                </a>
                                                            </th>
                                                            <th></th>
                                                        </tr>
                                                        <tr v-for="(colli,k) in booking.colli_data">
                                                            <td>
                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <input type="text"
                                                                               autocomplete="off"
                                                                               required
                                                                               class="form-control  border-0 py-0 shadow-none form-input"
                                                                               placeholder="reference"
                                                                               v-model="colli.reference"
                                                                               :disabled="!isEditingColli"
                                                                               :class="{view: !isEditingColli}">
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>

                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <input type="text"
                                                                               autocomplete="off"
                                                                               class="form-control  border-0 py-0 shadow-none form-input"
                                                                               v-model="colli.name"
                                                                               :disabled="!isEditingColli"
                                                                               :class="{view: !isEditingColli}">
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center div-focus':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <div
                                                                            @click="removeSingleColliFromBatch(colli.colli_batch)"
                                                                            class="material-icons-outlined cursor-pointer text-primary"
                                                                            title="remove colli">remove
                                                                        </div>
                                                                        <span class="colli-number"> {{
                                                                                colli.totalColliAmountByColliBatch ||
                                                                                colli.colli
                                                                            }}
                                                                        </span>
                                                                        <div
                                                                            @click="addSingleColliToBatch(colli.colli_batch)"
                                                                            class="material-icons-outlined cursor-pointer text-primary"
                                                                            title="add colli">add
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <input type="text"
                                                                               autocomplete="off"
                                                                               required
                                                                               class="form-control  border-0 py-0 shadow-none form-input"
                                                                               v-model="colli.totalVolume"
                                                                               :disabled="!isEditingColli"
                                                                               :class="{view: !isEditingColli}"
                                                                               @change="recalculateCollis"
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <input type="text"
                                                                               autocomplete="off"
                                                                               required
                                                                               class="form-control  border-0 py-0 shadow-none form-input"
                                                                               v-model="colli.totalWeight"
                                                                               :disabled="!isEditingColli"
                                                                               :class="{view: !isEditingColli}"
                                                                               @change="recalculateCollis"
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div v-if="colli.location!==null">
                                                                    <div
                                                                        v-for="(location,key) in colli.grouppedByLocations">

                                                                        {{ key.split('(')[0] }}
                                                                        ({{ location }})
                                                                        ({{ key.split('(')[1] }} <br/>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td v-if="canEdit || booking.status_id===1">
                                                                <div>
                                                                    <a @click="isEditingColli = !isEditingColli;booking.colliDataChanged=!booking.colliDataChanged"
                                                                       class="text-decoration-none"
                                                                       v-if="!isEditingColli  && !booking.deleted_at">
                                                                        <div
                                                                            class="material-icons-outlined cursor-pointer text-primary">
                                                                            edit
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                            <td v-if="canEdit || booking.status_id===1">
                                                                <div title="delete colli"
                                                                     @click="deleteColli(k, colli.isExisting, colli.id)"
                                                                     class="material-icons-outlined cursor-pointer
                                                                     text-primary" bis_skin_checked="1">
                                                                    delete
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="canEdit || booking.status_id===1">
                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           placeholder="123456 (order #)"
                                                                           v-model="colli.reference">
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           placeholder="Blue chair"
                                                                           v-model="colli.name">
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           v-model="colli.colli">
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           v-model="colli.volume"
                                                                    >
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           v-model="colli.weight"
                                                                    >
                                                                </div>
                                                            </td>
                                                            <td></td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div class="btn btn-success sm" @click="addColli()">
                                                                        <div
                                                                            class="material-icons-outlined cursor-pointer mr-1">
                                                                            add_circle
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>

                                                            </td>
                                                        </tr>
                                                        <tr v-if="showClientColliList">
                                                            <td colspan="11">
                                                                <div>
                                                                    <b>Products already in the Step Transport warehouse:
                                                                    </b>
                                                                </div>
                                                                <div class="col-md-3 search-colli">
                                                                    <div class="form-group">
                                                                        <input type="text" autocomplete="off"
                                                                               @input="findColliByReference($event)"
                                                                               class="form-control"
                                                                               placeholder="Search for colli reference...">
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-for="colli in clientColliList">
                                                            <td>
                                                                <div class="form-group">
                                                                    {{ colli.reference }}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    {{ colli.name }}
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div class="form-group">
                                                                    {{ colli.totalColliAmountByColliBatch }}
                                                                </div>
                                                            </td>

                                                            <td>
                                                                {{ colli.volume }}
                                                            </td>
                                                            <td>
                                                                {{ colli.weight }}
                                                            </td>
                                                            <td>
                                                                <div v-if="colli.location!==null">
                                                                    {{ colli.location.name }}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div class="btn btn-success sm"
                                                                         @click="addExistingColli(colli.id)">
                                                                        <div
                                                                            class="material-icons-outlined cursor-pointer mr-1">
                                                                            add_circle
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>

                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <div
                                                        v-if="!showClientColliList && (canEdit || booking.status_id===1)"
                                                        class="btn add-warehouse btn-success"
                                                        @click="getClientColliList">
                                                        Add from Step Warehouse
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 action-block save-button" v-if="!booking.deleted_at">
                        <button v-if="canEdit" type="submit" class="btn btn-primary float-left"
                                @click="validation()">
                            Save
                        </button>
                        <div v-if="booking.status_id===1 && canEditPrices" @click="confirmBooking()"
                             class="btn btn-success d-flex align-items-center float-left button-success-text confirm-button"
                             title="Confirm booking">
                            <span class="">Confirm booking</span>
                        </div>

                        <div v-if="canDelete"
                             @click="deleteBooking()"
                             class="btn btn-primary d-flex align-items-center float-left delete-button"
                             title="Delete booking">
                            <div class="material-icons-outlined cursor-pointer mr-1"
                                 title="delete">delete
                            </div>
                            <div>Delete Booking</div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <br/>
        <br/>
        <a :href="backUrl" title="Back" class="text-decoration-none" @click.prevent="goBack">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Do you want to change the date of the drop-off trip?</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="reload"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addDropoffDate">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <date-picker
                                        required
                                        manual-input
                                        v-model="dropoffDate.date" valueType="format"
                                        input-class="border-0 py-0 shadow-none form-input"
                                        :lang="datePickerOptions.lang"
                                        placeholder="dd-mm-yyyy" format="DD-MM-YYYY">
                                    </date-picker>
                                </div>
                            </div>

                            <button class="btn btn-success">
                                Confirm
                            </button>
                            <div class="btn btn-primary mark-delivered" @click="reload">
                                Cancel
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalLog}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Changed data</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalLog(logData.id)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="logData.description">
                            <div v-if="[logActionCustomerChangedOptions, logActionUpdatedAfterConfirmation].includes(logData.action)">
                                <div v-for="(service,key) in JSON.parse(logData.description)">
                                    <div v-if="service.name && (service.value || service.price)">
                                        <span>{{ service.name }}:</span>
                                        <span v-if="[newDeliveryDateKey, newPickupDateKey].includes(key)">
                                            {{ service.value.replace(/\(.*/, '') }}
                                        </span>
                                        <div v-else-if="key === 'ChangesAddress' || key === 'ChangesAddressPickup'">
                                            <div v-for="(value, field) in service.value" :key="field">
                                                {{ field === 'country_id' ? 'country' : field }}:
                                                {{ field === 'country_id' ? countryName(value) : (value || '—') }}
                                            </div>
                                        </div>
                                        <span v-else-if="!key.includes('ShorterTimeInterval')">{{ service.value }}</span>
                                        <span v-else>{{ service.value.from }} - {{ service.value.to }}</span>
                                        <span v-if="service.price">(+{{ logOptionPrice(service.price) }} kr.)</span>
                                    </div>
                                    <div v-else-if="service.key === primeKey">
                                        <div v-for="primeService in service" v-if="typeof primeService === 'object'">
                                            <span>{{ primeService.name }}:</span>
                                            <span>({{ logOptionPrice(primeService.price) }} kr.)</span>
                                        </div>
                                    </div>
                                    <div v-else-if="service.key === addOnsKey">
                                        <div v-for="addOnService in service" v-if="typeof addOnService === 'object'">
                                            <span>{{ addOnService.name }}:</span>
                                            <span>({{ logOptionPrice(addOnService.price) }} kr.)</span>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div>Total price</div>
                                <div> {{ calcTotalForLog(JSON.parse(logData.description)) }} kr.</div>
                            </div>
                            <div v-else-if="[logActionAddOnsUpdated, logActionCustomServicesUpdated].includes(logData.action)">
                                {{ logData.description }}
                            </div>
                            <div v-else>
                                <div v-for="(detail,k) in JSON.parse(logData.description)">
                                    <b>{{ k }}:</b>
                                    {{ detail[0] }} -> {{ detail[1] }}
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalLog" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalSmsLog}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document" style="max-width: 800px;">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Sms log. Log id: {{ smsLogData.id }}</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalSmsLog(smsLogData.id)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div><strong>Type:</strong> {{ smsLogData.title }}</div>
                        <div><strong>Recipient:</strong> {{ smsLogData.sent_to }}</div>
                        <div><strong>Status:</strong> {{ smsLogData.status }}</div>
                        <div><strong>Sent at:</strong> {{ smsLogData.sent_at }}</div>
                        <div v-if="smsLogData.details && smsLogData.details.errorCode">
                            <strong>Error code:</strong>
                            <a :href="'https://www.twilio.com/docs/api/errors/' + smsLogData.details.errorCode"
                               target="_blank">
                                {{ smsLogData.details.errorCode }}
                            </a>
                        </div>
                        <div v-if="smsLogData.details && smsLogData.details.errorMessage">
                            <strong>Error message:</strong> {{ smsLogData.details.errorMessage }}
                        </div>
                        <div v-if="smsLogData.details && smsLogData.details.text">
                            <strong>Sms text:</strong>
                            <div>{{ smsLogData.details.text }}</div>
                        </div>
                        <br>
                        <div v-if="smsLogData.sms_flow_trackings && smsLogData.sms_flow_trackings.length && role !== roleUser">
                            <strong>Tracking details:</strong>
                        </div>
                        <div v-for="tracking in smsLogData.sms_flow_trackings" class="mb-4" v-if="role !== roleUser">
                            <div>
                                <strong>Link: </strong>
                                <a :href="tracking.details.link"
                                   target="_blank">
                                    {{ tracking.details.link }}
                                </a>
                            </div>
                            <div>
                                <strong>Visit was finished at: </strong>
                                <span>{{ tracking.details.lastVisited ?? '' }}</span>
                            </div>
                            <div v-for="(stepData, stepName) in tracking.details.steps">
                                <div>
                                    <strong>{{ stepName }}: </strong>
                                    <span v-if="stepData.visited_at">
                                        visited at {{ formatDateTime(stepData.visited_at) }}
                                    </span>
                                </div>
                                <div v-if="stepData.info && stepData.info.length" v-for="item in stepData.info">
                                    <span :class="item.includes('Error') ? 'text-danger' : ''">{{ item }}</span>
                                </div>
                                <div v-if="stepData.errors && stepData.errors.length" v-for="item in stepData.errors">
                                    <span class="text-danger">{{ item }}</span>
                                </div>
                            </div>
                            <div class="mt-2" v-if="tracking.details.selected_data.length === undefined">
                                <div>
                                    <strong>Selected data:</strong>
                                </div>
                                <div>
                                    <customer-options
                                        :options="tracking.details.selected_data"
                                        :prime-key="primeKey"
                                        :add-ons-key="addOnsKey"
                                        :payment-statuses="paymentStatuses"
                                        :price-includes-vat="true"
                                    ></customer-options>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalSmsLog" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalType}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change type
                            <span v-if="booking.booking_type===1"> Internal → External </span>
                            <span v-else> External → Internal </span>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalType"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div v-if="booking.booking_type===1">
                            <div class="form-group">
                                <div class="align-items-center bg-white rounded-lg div-focus">
                                    <v-select
                                        :options="driverList"
                                        v-model="booking.driver"
                                        :clearSearchOnSelect="false"
                                        label="name"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="align-items-center bg-white rounded-lg div-focus">
                                    <input type="text"
                                           autocomplete="off"
                                           required
                                           class="form-control py-0 shadow-none form-input"
                                           placeholder="cost price"
                                           v-model="booking.cost_price"
                                    >
                                </div>
                            </div>
                        </div>

                        <button class="btn btn-success" @click="changeBookingType">
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalType" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalMessage}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Important!</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalMessage"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>{{ warningMessage }} </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="toggleModalMessage">
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalMessage" class="modal-backdrop fade show"></div>

        <div
            ref="modalForceSms"
            class="modal fade"
            :class="{show, 'd-block': activeModalForceSms}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Important!</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalForceSms"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>Er du sikker på at du vil sende {{ selectedSmsTemplate.title }} til denne kunde igen?</div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="smsSend(selectedSmsTemplate, true)">
                            Ja
                        </button>
                        <button class="btn btn-primary" @click="toggleModalForceSms">
                            Nej
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalForceSms" class="modal-backdrop fade show"></div>

        <div
            ref="modalCopyBooking"
            class="modal fade"
            :class="{show, 'd-block': activeModalCopyBooking}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Copy booking</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalCopyBooking"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 d-flex justify-content-between">
                            <div>
                                <div>
                                    <label for="booking-copy-dropoff-date">
                                        <strong>Pickup date</strong>
                                    </label>
                                </div>
                                <div style="display:inline-block; width:200px;">
                                    <div
                                        class="rounded-lg div-focus border border-2">
                                        <date-picker
                                            manual-input
                                            v-model="bookingCopy.pickupDate"
                                            valueType="format"
                                            input-class="border-0 py-0 ml-0 shadow-none form-input"
                                            placeholder="date"
                                            :lang="datePickerOptions.lang"
                                            format="DD-MM-YYYY"
                                            id="booking-copy-dropoff-date"
                                            :clearable="false"
                                            :disabled-date="disabledDates"
                                        >
                                        </date-picker>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label class="newInput">
                                    <strong>Pickup/Linehaul delivered</strong>
                                    <input type="checkbox" v-model="bookingCopy.pickupAndLinehaulDelivered">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <div>
                                <label for="booking-copy-dropoff-date">
                                    <strong>Dropoff date</strong>
                                </label>
                            </div>
                            <div style="display:inline-block; width:200px;">
                                <div
                                    class="rounded-lg div-focus border border-2">
                                    <date-picker
                                        manual-input
                                        v-model="bookingCopy.dropoffDate"
                                        valueType="format"
                                        input-class="border-0 py-0 ml-0 shadow-none form-input"
                                        placeholder="date"
                                        :lang="datePickerOptions.lang"
                                        format="DD-MM-YYYY"
                                        id="booking-copy-dropoff-date"
                                        :clearable="false"
                                        :disabled-date="disabledDates"
                                    >
                                    </date-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="copyBooking">
                            Copy
                        </button>
                        <button class="btn btn-primary" @click="toggleModalCopyBooking">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalCopyBooking" class="modal-backdrop fade show"></div>

        <div
            ref="modalForceSms"
            class="modal fade"
            :class="{show, 'd-block': activeModalChangePrice}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Prices will be changed</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalChangePrice"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div>
                                <strong>Product price:</strong> {{ booking.product_price }} -->
                                {{ changePriceValues && changePriceValues.productPrice ? changePriceValues.productPrice : 0 }}
                            </div>
                        </div>
                        <div v-if="booking.services_data.length">
                            <div><strong>Service(s) price:</strong></div>
                            <div v-for="s in booking.services_data">
                                {{ s.name }}: {{ s.price }} -->
                                {{ changePriceValues ? changePriceValues.servicePrices[s.id] : 0 }}
                            </div>
                        </div>
                        <div v-if="booking.agreement_insurances_id">
                            <div>
                                <strong>Insurance price:</strong> {{ booking.insurances_price }} -->
                                {{ changePriceValues && changePriceValues.insurancesPrices ? changePriceValues.insurancesPrices : 0 }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="setPrices">
                            Continue
                        </button>
                        <button class="btn btn-success" @click="continueWithPrice">
                            Continue with current price
                        </button>
                        <button class="btn btn-primary"
                                @click="toggleModalChangePrice"
                                v-if="changePriceModalTriggerredUponAddingColli"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalChangePrice" class="modal-backdrop fade show"></div>

        <div
            ref="modalDriverCostExclusionNote"
            class="modal fade"
            :class="{show, 'd-block': activeModalDriverCostExclusionNote}"
            tabindex="-1"
            role="dialog"
            aria-modal="true"
            data-testid="driver-cost-exclusion-note-modal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div>
                            <h5 class="modal-title mb-1">Reason for excluding {{ driverCostExclusionType }} driver cost</h5>
                            <small class="text-muted">
                                The {{ driverCostExclusionType }} trip will remain in the report with a price of 0.
                            </small>
                        </div>
                        <button
                            type="button"
                            class="close"
                            aria-label="Close"
                            @click="cancelDriverCostExclusionNote"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="driver-cost-exclusion-note">
                            <strong>Explanation</strong>
                        </label>
                        <textarea
                            id="driver-cost-exclusion-note"
                            v-model="driverCostExclusionNoteDraft"
                            class="form-control"
                            :class="{'is-invalid': driverCostExclusionNoteError}"
                            rows="5"
                            maxlength="2000"
                            :placeholder="`Describe why this ${driverCostExclusionType} trip should not count towards the driver's cost`"
                            data-testid="driver-cost-exclusion-note-input"
                            @input="driverCostExclusionNoteError = ''"
                        ></textarea>
                        <div v-if="driverCostExclusionNoteError" class="invalid-feedback d-block">
                            {{ driverCostExclusionNoteError }}
                        </div>
                        <small class="form-text text-muted text-right">
                            {{ driverCostExclusionNoteDraft.length }}/2000
                        </small>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-primary"
                            data-testid="confirm-driver-cost-exclusion-note"
                            @click="confirmDriverCostExclusionNote"
                        >
                            Save reason
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="cancelDriverCostExclusionNote"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalDriverCostExclusionNote" class="modal-backdrop fade show"></div>

        <div
            ref="modalDriverCostExclusionRemoval"
            class="modal fade"
            :class="{show, 'd-block': activeModalDriverCostExclusionRemoval}"
            tabindex="-1"
            role="dialog"
            aria-modal="true"
            data-testid="driver-cost-exclusion-removal-modal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div>
                            <h5 class="modal-title mb-1">Remove {{ driverCostExclusionType }} driver cost exclusion?</h5>
                            <small class="text-muted">
                                Choose whether the existing explanation should be kept on the booking.
                            </small>
                        </div>
                        <button
                            type="button"
                            class="close"
                            aria-label="Close"
                            @click="cancelDriverCostExclusionRemoval"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="booking[driverCostExclusionNoteField(driverCostExclusionType)]"
                             class="driver-cost-exclusion-note">
                            <strong>Current reason:</strong>
                            {{ booking[driverCostExclusionNoteField(driverCostExclusionType)] }}
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <div>
                            <button
                                type="button"
                                class="btn btn-primary"
                                data-testid="keep-driver-cost-exclusion-note"
                                @click="confirmDriverCostExclusionRemoval(false)"
                            >
                                Keep reason
                            </button>
                            <button
                                type="button"
                                class="btn btn-danger"
                                data-testid="delete-driver-cost-exclusion-note"
                                @click="confirmDriverCostExclusionRemoval(true)"
                            >
                                Delete reason
                            </button>
                        </div>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="cancelDriverCostExclusionRemoval"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalDriverCostExclusionRemoval" class="modal-backdrop fade show"></div>

        <loading :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>

        <div class="modal fade" :class="{show, 'd-block': showDropoffConfirmModal}" style="z-index: 1060;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Confirm Change</h5>
                        <button type="button" class="close" @click="cancelDropoffDateChange">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            Booking will have either a storage fee or deadline fee from the date last colli on booking have been received. Which fee should be added to booking?
                        </p>
                        <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox"
                                   class="custom-control-input"
                                   id="storage_fee_confirmed"
                                   v-model="storageFeeConfirmed"
                                   @change="onFeeSelect('storage_fee')"
                            >
                            <label class="custom-control-label" for="storage_fee_confirmed">
                                Storage fee (~ {{ calculatedFees.storage_fee_value ?? 0 }} kr) - <strong>Client</strong> pays
                            </label>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox"
                                   class="custom-control-input"
                                   id="deadline_fee_confirmed"
                                   v-model="deadlineFeeConfirmed"
                                   @change="onFeeSelect('deadline_fee')"
                            >
                            <label class="custom-control-label" for="deadline_fee_confirmed">
                                Deadline fee (~ {{ calculatedFees.deadline_fee_value ?? 0 }} kr) - <strong>STEP</strong> pays
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cancelDropoffDateChange">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="confirmDropoffDateChange">Ok</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showDropoffConfirmModal" class="modal-backdrop fade show" style="z-index: 1050;"></div>

        <div class="modal fade" :class="{show: showDeleteColliModal, 'd-block': showDeleteColliModal}" style="z-index: 1060;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete booking - what about the goods?</h5>
                        <button type="button" class="close" @click="cancelDeleteColli">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            This booking has
                            <strong>{{ receivedColliInfo.received }}</strong>
                            received colli.
                            Should the goods be moved to WMS or deleted together with the booking?
                        </p>
                        <p v-if="receivedColliInfo.not_received > 0" class="mb-0">
                            <small>
                                {{ receivedColliInfo.not_received }} colli that
                                {{ receivedColliInfo.not_received === 1 ? 'has' : 'have' }}
                                not been received will be deleted in both cases.
                            </small>
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cancelDeleteColli">
                            Cancel
                        </button>
                        <button type="button" class="btn btn-primary" @click="confirmDeleteBookingMoveColliToWms">
                            Move goods to WMS
                        </button>
                        <button type="button" class="btn btn-danger" @click="confirmDeleteBookingWithColli">
                            Delete goods with booking
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showDeleteColliModal" class="modal-backdrop fade show" style="z-index: 1050;"></div>
    </div>
</template>

<script>
import driverMixin from '../mixins/driverMixin';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import smsMixin from "../mixins/smsMixin";
import Loading from "vue-loading-overlay";
import priceMixin from "../mixins/priceMixin";
import dateTimeMixin from "../mixins/dateTimeMixin";
import moment from "moment";
import modalMixin from "../mixins/modalMixin";
import CustomerOptions from "./reusable/CustomerOptions.vue";
import PostConfirmEditPanel from "./booking/PostConfirmEditPanel.vue";

export default {
    name: "BookingEdit",
    mixins: [driverMixin, datePickerOptionsMixin, smsMixin, priceMixin, dateTimeMixin, modalMixin],
    components: {Loading, DatePicker, VueTimepicker, CustomerOptions, PostConfirmEditPanel},
    props: {
        url: {type: String, required: true},
        backUrl: {type: String, required: true},
        role: {type: String, required: true},
        roleUser: {type: String, required: true},
        canViewPrices: {type: Boolean, required: true},
        canEditPrices: {type: Boolean, required: true},
        newDeliveryDateKey: {type: String, required: true},
        newPickupDateKey: {type: String, required: true},
        permitsKey: {type: String, required: true},
        shorterTimeIntervalKey: {type: String, required: true},
        insuranceKey: {type: String, required: true},
        primeKey: {type: String, required: true},
        addOnsKey: {type: String, required: true},
        logActionCustomerChangedOptions: {type: String, required: true},
        logActionAddOnsUpdated: {type: String, required: true},
        logActionCustomServicesUpdated: {type: String, required: true},
        logActionUpdated: {type: String, required: true},
        logActionUpdatedAfterConfirmation: {type: String, required: true},
        postConfirmOptionsUrl: {type: String, required: true},
        postConfirmApplyDropoffUrl: {type: String, required: true},
        postConfirmApplyPickupUrl: {type: String, required: true},
        availablePermits: {type: Array, required: true},
        smsTemplates: {type: Array, required: true},
        paymentStatuses: {type: Object, required: true},
        types: {type: Object, required: true},
        typeAdHoc: {type: Number, required: true},
        maxIntervalExceeded: {type: Boolean, required: true},
        userTypeClient: {type: String, required: true},
        sendToDropoff: {type: Number, required: true},
        fileTypeImage: {type: String, required: true},
        fileTypeSignature: {type: String, required: true},
        tripStatusFailed: {type: Number, required: true},
        specialPermissions: {type: Array|Object, default: []},
        driverTypeExternal: {type: Number, required: true},
        agreementAddOnsPickupProp: {type: Array, required: true},
        agreementAddOnsDropoffProp: {type: Array, required: true},
        customServices: {type: Array, required: true},
        tripTypes: {type: Object, required: true},
        tripTypePickup: {type: Number, required: true},
        tripTypeDropoff: {type: Number, required: true},
        addOnShorterIntervalPickup: {type: Number, default: 0},
        addOnShorterIntervalDropoff: {type: Number, default: 0},
    },
    data() {
        return {
            countryList: {},
            validationErrors: '',
            vat: 0.25,
            isEditingPickup: false,
            isEditingDropoff: false,
            isEditingNote: false,
            isEditingColli: false,
            isEditingProduct: false,
            isEditingContact: false,
            isEditingStatus: false,
            isEditingTrip: false,
            isEditingExternalDriver: false,
            activeModalInterval: false,
            activeModalIntervalLog: false,
            activeModalIntervalSmsLog: false,
            activeModalIntervalType: false,
            activeModalCopyBooking: false,
            activeModalMessage: false,
            activeModalForceSms: false,
            activeModalChangePrice: false,
            showDeleteColliModal: false,
            receivedColliInfo: {received: 0, not_received: 0},
            activeModalDriverCostExclusionNote: false,
            activeModalDriverCostExclusionRemoval: false,
            modalOpen: false,
            show: false,
            dropoffDate: {date: this.predefinedTripData()},
            deliveredDate: {
                pickupDate: null,
                dropoffDate: null,
                linehaulDate: this.predefinedTripData(),
            },
            booking: {
                product_time_units_initial: 0,
                service_time_units_initial: 0,
                agreement_id: 0,
                dropoff_address: {country: {name: 'Denmark'}},
                pickup_address: {country: {name: 'Denmark'}},
                product: '',
                pickup_trip: '',
                dropoff_trip: '',
                linehaul_trip: '',
                client_data: {'primary_contact': ''},
                services_data: {},
                colli_data: {},
                new_services: [],
                driver: {},
            },
            clientColliList: {},
            showClientColliList: false,
            colli_deleted: [
                {id: ''},
            ],
            colli: {
                'id': '',
                'reference': '',
                'name': '',
                'colli': '',
                'height': '',
                'width': '',
                'measure': '',
                'volume': '',
                'weight': '',
                'totalVolume': '',
                'totalWeight': '',
                'isExisting': 0
            },
            existingColli: {},
            referenceExistsMessage: '',
            services: {},
            serviceIds: [],
            isSubmit: false,
            logData: {},
            smsLogData: {},
            communicationLog: {},
            loading: false,
            bookingPermits: [],
            insuranceInCustomerOptions: false,
            warningMessage: '',
            selectedSmsTemplate: {},
            bookingCopy: {
                dropoffDate: '',
                pickupDate: '',
                pickupAndLinehaulDelivered: false
            },
            changePriceMessage: '',
            changePriceValues: '',
            changePriceModalTriggerredUponAddingColli: false,
            canEdit: false,
            canDelete: false,
            excludeFromDriverCostReport: {pickup: false, dropoff: false},
            driverCostExclusionNoteDraft: '',
            driverCostExclusionNoteError: '',
            driverCostExclusionNoteMode: 'exclude',
            driverCostExclusionType: 'pickup',
            agreementAddOnsPickup: this.agreementAddOnsPickupProp,
            agreementAddOnsDropoff: this.agreementAddOnsDropoffProp,
            selectedAddOnsPickup: [],
            selectedAddOnsDropoff: [],
            selectedCustomService: '',
            newCustomService: '',
            showShorterIntervalOptionsPickup: false,
            showShorterIntervalOptionsDropoff: false,
            shorterIntervalOptionsPickup: {},
            shorterIntervalOptionsDropoff: {},
            selectedAddOnOptions: {},
            previousDropoffDate: null,
            showDropoffConfirmModal: false,
            calculatedFees: {
                storage_fee_value: 0,
                deadline_fee_value: 0
            },
            storageFeeConfirmed: true,
            deadlineFeeConfirmed: false,
            availableWeekDaysDropoff: {
                1: {from: '00:00', to: '00:00', highlight: false},
                2: {from: '00:00', to: '00:00', highlight: false},
                3: {from: '00:00', to: '00:00', highlight: false},
                4: {from: '00:00', to: '00:00', highlight: false},
                5: {from: '00:00', to: '00:00', highlight: false},
            },
            availableWeekDaysPickup: {
                1: {from: '00:00', to: '00:00', highlight: false},
                2: {from: '00:00', to: '00:00', highlight: false},
                3: {from: '00:00', to: '00:00', highlight: false},
                4: {from: '00:00', to: '00:00', highlight: false},
                5: {from: '00:00', to: '00:00', highlight: false},
            },
            showSmsTracking: 0
        }
    },
    computed: {
        // Clients change confirmed booking details through Upgrade.
        // STEP staff retain ordinary editing under the existing permissions.
        postConfirmLocked() {
            return !!this.booking.id &&
                this.booking.status_id >= 2 &&
                !this.hasSpecialPermission('can_bypass_post_confirm_lock');
        },
    },
    methods: {
        countryName(id) {
            const country = Object.values(this.countryList).find(country => Number(country.id) === Number(id));
            return country ? country.name : id;
        },
        logOptionPrice(price) {
            return this.logData.action === this.logActionUpdatedAfterConfirmation ?
                (Number(price) * (1 + this.vat)).toFixed(2) :
                this.calculatePriceWithVatAndRoundToNearestTens(price);
        },
        getLinehaulTypeLabel(type) {
            const labels = {
                '0-0': 'None',
                '1-2': 'EAST-WEST',
                '2-1': 'WEST-EAST'
            };
            return labels[type] || type || 'None';
        },
        validation() {
            this.isSubmit = true;
        },
        async updateBooking() {
            this.booking.new_services = this.serviceIds;
            this.booking.delivered_date = this.deliveredDate;
            this.booking.selectedAddOns = this.selectedAddOnsPickup.concat(this.selectedAddOnsDropoff);
            axios.patch(`/bookings/${this.booking.id}`, this.booking).then((response) => {
                window.location.reload();
            }).catch(e => {
                this.validationErrors = e.response.data.errors
            })
        },
        confirmBooking() {
            axios.post(`/booking-confirm/${this.booking.id}`).then((response) => {
                window.location.reload();
            }).catch(err => console.log(err))
        },
        deleteBooking() {
            // Received goods must not disappear silently: ask the user what should
            // happen to them. Colli that have not been received are always deleted.
            axios.get(`/bookings/${this.booking.id}/received-colli-info`)
                .then(({data}) => {
                    this.receivedColliInfo = data.data;

                    if (this.receivedColliInfo.received > 0) {
                        this.showDeleteColliModal = true;
                        return;
                    }

                    if (confirm("Are you sure you want to delete this booking?")) {
                        this.sendDeleteBooking(false);
                    }
                })
                .catch(error => {
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(error.response)
                });
        },
        cancelDeleteColli() {
            this.showDeleteColliModal = false;
        },
        confirmDeleteBookingMoveColliToWms() {
            this.showDeleteColliModal = false;
            this.sendDeleteBooking(false);
        },
        confirmDeleteBookingWithColli() {
            this.showDeleteColliModal = false;
            this.sendDeleteBooking(true);
        },
        sendDeleteBooking(deleteReceivedColli) {
            axios.delete(`/bookings/${this.booking.id}`, {
                params: {deleteReceivedColli: deleteReceivedColli ? 1 : 0}
            }).then((response) => {
                window.location.href = `/bookings`;
            }).catch(error => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(error.response)
            });
        },
        fetchData() {
            let dataFetchUrl = `${this.url}`
            axios.get(dataFetchUrl)
                .then(({data}) => {
                    this.booking = data.data;
                    if (this.booking.storage_fee_confirmed !== undefined) {
                        this.storageFeeConfirmed = this.booking.storage_fee_confirmed;
                    } else {
                        this.booking.storage_fee_confirmed = this.storageFeeConfirmed;
                    }
                    if (this.booking.deadline_fee_confirmed !== undefined) {
                        this.deadlineFeeConfirmed = this.booking.deadline_fee_confirmed;
                    } else {
                        this.booking.deadline_fee_confirmed = this.deadlineFeeConfirmed;
                    }
                    if (this.booking.storage_fee_value === undefined) {
                        this.$set(this.booking, 'storage_fee_value', 0);
                    }
                    if (this.booking.deadline_fee_value === undefined) {
                        this.$set(this.booking, 'deadline_fee_value', 0);
                    }
                    this.booking.colliDataChanged = false;
                    this.booking.colliBatchNumberChanged = false;
                    this.booking.product_time_units_initial = data.data.product_time_units;
                    if (data.data.product_time_units === 0) {
                        this.booking.product_price_per_unit = data.data.product_price;
                    } else {
                        this.booking.product_price_per_unit = data.data.product_price / data.data.product_time_units;
                    }
                    this.excludeFromDriverCostReport = {
                        pickup: !!this.booking.exclude_pickup_from_driver_cost_report,
                        dropoff: !!this.booking.exclude_dropoff_from_driver_cost_report,
                    };
                    this.analyzeCustomerOptions();
                    this.checkMaxInterval();
                    axios.get(`/service-list/${this.booking.agreement_id}`, {params: {userType: this.userTypeClient}})
                        .then(({data}) => {
                            this.services = data.data;
                            Object.entries(this.booking.services_data).forEach(entry => {
                                const [key, value] = entry;
                                this.serviceIds.push(value.id)
                            });
                        }).catch(error => this.services = [])
                    axios.get(`/colli-list?bookingId=${this.booking.id}&groupByColliBatch=true&isForBookingEdit=true`)
                        .then(({data}) => {
                            this.booking.colli_data = data.data;
                        }).catch()
                    if (this.role !== 'user') {
                        axios.get(`/communication-log/${this.booking.id}`)
                            .then(({data}) => {
                                this.communicationLog = data.result;
                            }).catch()

                        this.fetchDriverList(true);
                    }

                    this.canEdit = this.role !== 'user';
                    if (!this.canEdit && this.booking.status_id < 9) {
                        this.canEdit = true;
                        if (this.booking.trips) {
                            this.booking.trips.forEach((trip) => {
                                if (trip.optimoroute_result && trip.optimoroute_result.includes('Transferred:')) {
                                    this.canEdit = false;
                                }

                            });
                        }
                    }

                    if (this.booking.agreementAddOns.length) {
                        let prefix;
                        this.booking.agreementAddOns.forEach((agreementAddOn) => {
                            prefix = agreementAddOn.add_on.type === this.tripTypePickup ? 'Pickup' : 'Dropoff';
                            this[`selectedAddOns${prefix}`].push({
                                id: agreementAddOn.id,
                                add_on_id: agreementAddOn.add_on_id,
                                key: agreementAddOn.add_on.key,
                                name: agreementAddOn.add_on.name,
                                price: agreementAddOn.pivot.price,
                                selected_option: agreementAddOn.pivot.selected_option ?? null,
                            });
                            if (agreementAddOn.add_on.id === this.addOnShorterIntervalPickup) {
                                this.showShorterIntervalOptionsPickup = true;

                            } else if (agreementAddOn.add_on.id === this.addOnShorterIntervalDropoff) {
                                this.showShorterIntervalOptionsDropoff = true;
                            }

                            if ([this.addOnShorterIntervalPickup, this.addOnShorterIntervalDropoff].includes(agreementAddOn.add_on.id))
                            this.$set(this.selectedAddOnOptions, agreementAddOn.add_on.id, {
                                option: agreementAddOn.pivot.selected_option,
                                price: agreementAddOn.pivot.price
                            });
                        })
                    }

                    this.canDelete = this.booking.can_delete;
                }).catch(error => this.booking = []);

            axios.get(`/country-list`)
                .then(({data}) => {
                    this.countryList = data.result;
                }).catch()
        },
        fetchDriverList(onInit) {
            if (!onInit) {
                this.booking.driver = {}
            }
            this.getDriverList(this.driverTypeExternal);
            if (this.driverList.length > 0) {
                this.booking.driver = {'id': this.driverList[1].id, 'name': this.driverList[1].name}
            }
        },
        scrollToElement(options, elementToScroll) {
            const el = this.$el.getElementsByClassName(elementToScroll)[0];
            if (el) {
                el.scrollIntoView(options);
            }
        },
        deleteColli(k, isExisting, id) {
            if (typeof (isExisting) === 'undefined') {
                this.colli_deleted.push({'id': id});
            }
            this.booking.colli_deleted = this.colli_deleted;
            this.booking.colli_data = this.booking.colli_data.filter((x, i) => i !== k);
            this.recalculateCollis();
        },
        getClientColliList() {
            axios.get(`/colli-list?clientIdSingle=${this.booking.client_data.id}&groupByColliBatch=true&excludeDelivered=true&excludeAssigned=true`)
                .then(({data}) => {
                    this.clientColliList = data.data;
                    this.showClientColliList = true;
                }).catch(error => this.clientColliList = [])
        },
        resetColli() {
            this.colli = {
                'id': '',
                'reference': '',
                'name': '',
                'colli': '',
                'height': '',
                'width': '',
                'measure': '',
                'volume': '',
                'weight': '',
                'totalVolume': '',
                'totalWeight': '',
                'isExisting': 0
            }
        },
        async addExistingColli(id) {
            let existingColliData = this.clientColliList.filter(p => p.id == id)[0];

            const totalVolume = parseFloat(this.booking.volume) + parseFloat(existingColliData.totalVolume);
            const totalWeight = parseFloat(this.booking.weight) + parseFloat(existingColliData.totalWeight);
            this.changePriceModalTriggerredUponAddingColli = true;

            this.resetColli();
            this.existingColli = {
                id: id,
                reference: existingColliData.reference,
                name: existingColliData.name,
                colli: existingColliData.colli,
                totalColliAmountByColliBatch: existingColliData.colli,
                height: existingColliData.height,
                width: existingColliData.width,
                totalVolume: existingColliData.totalVolume,
                totalWeight: existingColliData.totalWeight,
                isExisting: 1,
                isFromWarehouseList: 1,
                location: existingColliData.location
            };
            const res = await this.calculatePrice(totalVolume, totalWeight);

            if (res) {
                this.pushColli(this.existingColli);
                this.clientColliList = this.clientColliList.filter(p => p.id !== id);
            }
        },
        async addColli() {
            this.existingColli = {};
            if (this.colli.reference !== '' &&
                this.colli.name !== '' &&
                this.colli.colli !== '' &&
                this.colli.volume !== '' &&
                this.colli.weight !== ''
            ) {
                const totalVolume = parseFloat(this.booking.volume) + parseFloat(this.colli.volume);
                const totalWeight = parseFloat(this.booking.weight) + parseFloat(this.colli.weight);
                this.changePriceModalTriggerredUponAddingColli = true;
                const res = await this.calculatePrice(totalVolume, totalWeight);

                if (res) {
                    this.colli.location = null;
                    this.colli.isExisting = 0;
                    const newColli = {
                        reference: this.colli.reference,
                        name: this.colli.name,
                        colli: this.colli.colli,
                        totalColliAmountByColliBatch: this.colli.colli,
                        height: this.colli.height,
                        width: this.colli.width,
                        measure: this.colli.measure,
                        totalVolume: this.colli.volume,
                        totalWeight: this.colli.weight,
                        location: null,
                        isExisting: 0,
                    };
                    this.pushColli(newColli);
                }
            }
        },
        pushColli(newColli = null) {
            if (!newColli) {
                newColli = this.colli.reference ?
                    {
                        reference: this.colli.reference,
                        name: this.colli.name,
                        colli: this.colli.colli,
                        totalColliAmountByColliBatch: this.colli.colli,
                        height: this.colli.height,
                        width: this.colli.width,
                        measure: this.colli.measure,
                        totalVolume: this.colli.volume,
                        totalWeight: this.colli.weight,
                        location: null,
                        isExisting: 0,
                    } :
                    this.existingColli;
            }
            this.booking.colli_data.push(newColli);
            this.booking.volume = parseFloat(this.booking.volume) + parseFloat(newColli.totalVolume);
            this.booking.weight = parseFloat(this.booking.weight) + parseFloat(newColli.totalWeight);
            this.booking.colli = parseInt(this.booking.colli) + parseInt(newColli.totalColliAmountByColliBatch);
            this.booking.colliDataChanged = true;
        },
        recalculateCollis(e = '', recalculatePrice = true) {
            this.booking.volume = 0;
            this.booking.weight = 0;
            this.booking.colli = 0;
            this.booking.colliDataChanged = true;
            let colliAmount;
            this.booking.colli_data.forEach((colli) => {
                colliAmount = colli.totalColliAmountByColliBatch !== undefined ?
                    colli.totalColliAmountByColliBatch :
                    colli.colli;
                this.booking.volume = this.booking.volume + parseFloat(colli.totalVolume);
                this.booking.weight = this.booking.weight + parseFloat(colli.totalWeight);
                this.booking.colli = this.booking.colli + parseInt(colliAmount);
            });
            if (recalculatePrice) {
                this.changePriceModalTriggerredUponAddingColli = false;
                setTimeout(() => {
                    this.calculatePrice(this.booking.volume, this.booking.weight);
                }, 100);
            }
        },
        calculatePrice(totalVolume, totalWeight) {
            if (!this.canViewPrices) {
                return Promise.resolve(true);
            }

            this.changePriceValues = null;
            return new Promise((resolve) => {
                axios.get(`/recalculate-prices-for-booking/${this.booking.id}`, {
                    params:
                        {totalVolume: totalVolume, totalWeight: totalWeight}
                }).then((response) => {
                    console.log(response.data);
                    if (response.data.priceChanged) {
                        this.changePriceValues = response.data.prices;
                        this.toggleModalChangePrice();
                        resolve(false);
                    } else {
                        resolve(true);
                    }

                }).catch((error) => {
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(error.response.data);
                    resolve(false);
                });
            });
        },
        setPrices() {
            let price;
            price = this.changePriceValues.productPrice ?
                parseFloat(this.changePriceValues.productPrice) :
                0;
            this.$set(this.booking, 'product_price', price);

            if (this.booking.agreement_insurances_id) {
                price = this.changePriceValues.insurancesPrices ?
                    parseFloat(this.changePriceValues.insurancesPrices) :
                    0;
                this.$set(this.booking, 'insurances_price', price);
            }

            if (this.booking.services_data.length) {
                for (let i = 0; i < this.booking.services_data.length; i++) {
                    price = parseFloat(this.changePriceValues.servicePrices[this.booking.services_data[i].id]);
                    this.$set(this.booking.services_data[i], 'price', price);
                }
                this.$set(this.booking, 'total_service_price', this.changePriceValues.totalServicePrice);
            }

            this.continueWithPrice();
        },
        continueWithPrice() {
            if (this.changePriceModalTriggerredUponAddingColli) {
                this.pushColli();
            }
            this.toggleModalChangePrice();
        },
        findColliByReference(event) {
            this.clientColliList = {};
            axios.get(`/colli-list?searchByReference=${event.target.value}&clientIdSingle=${this.booking.client_data.id}&groupByColliBatch=true&excludeDelivered=true&excludeAssigned=true`)
                .then(({data}) => {
                    this.clientColliList = data.data;
                }).catch()
        },
        addSingleColliToBatch(batchId) {
            let colliData = this.booking.colli_data.filter(p => p.colli_batch == batchId)[0];
            if (!colliData.totalColliAmountByColliBatch) {
                colliData.totalColliAmountByColliBatch = colliData.colli;
            }
            colliData.totalColliAmountByColliBatch = parseInt(colliData.totalColliAmountByColliBatch) + 1;
            this.booking.colliBatchNumberChanged = true;
            this.recalculateCollis('', false);
        },
        removeSingleColliFromBatch(batchId) {
            let colliData = this.booking.colli_data.filter(p => p.colli_batch == batchId)[0];
            if (colliData.totalColliAmountByColliBatch > 1) {
                colliData.totalColliAmountByColliBatch -= 1;
                this.booking.colliBatchNumberChanged = true;
                this.recalculateCollis('', false);
            }
        },
        setTripDelivered(id, type) {
            if (this.booking.status_id < 2) {
                alert('Please confirm booking before handling trips');

            } else {
                axios.post(`/set-trip-delivered/${id}`).then(() => {
                    if (
                        (
                            this.booking.dropoff_trip &&
                            this.booking.dropoff_date === null &&
                            this.booking.dropoff_trip.status < 2
                        ) &&
                        ((type === 1 && !this.booking.linehaul_trip) || type === 2)
                    ) {
                        this.toggleModal();
                    } else {
                        window.location.reload();
                    }
                }).catch((error) => {
                    console.log(error.response.data);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                });
            }
        },
        setTripRejected(id, date = null) {

            if (this.booking.status_id < 2) {
                alert('Please confirm booking before handling trips');

            } else {
                const url = date ? `/set-trip-rejected/${id}/${date}` : `/set-trip-rejected/${id}`;
                axios.post(url).then(() => {
                    window.location.reload();
                }).catch((error) => {
                    console.log(error.response.data);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                });
            }
        },
        addDropoffDate() {
            if (this.dropoffDate.date !== null) {
                axios.post(`/update-dropoff-date/${this.booking.dropoff_trip.id}/${this.dropoffDate.date}`)
                    .then(({data}) => {
                        if (this.modalOpen) {
                            window.location.reload();
                        } else {
                            window.location.reload();
                        }
                    }).catch((error) => {
                    console.log(error.response.data);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                });
            }
        },
        predefinedTripData(isForDelivered = 0) {
            const currentDate = new Date();
            if (isForDelivered === 1) {
                return currentDate.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2})
                    + '-' + (currentDate.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
                    + '-' + currentDate.getFullYear();
            }
            const weekDays = 2;
            //exclude weekend days
            for (let i = 1; i <= weekDays; i++) {
                currentDate.setDate(currentDate.getDate() + 1);
                if (currentDate.getDay() === 6) {
                    currentDate.setDate(currentDate.getDate() + 2);
                } else if (currentDate.getDay() === 0) {
                    currentDate.setDate(currentDate.getDate() + 1);
                }
            }
            return currentDate.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '-' + (currentDate.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '-' + currentDate.getFullYear();
        },
        onChangeServiceId(event) {
            let value = parseInt(event.target.value);
            let index = this.serviceIds.indexOf(value);
            if (index !== -1) {
                this.serviceIds.splice(index, 1);
            } else {
                this.serviceIds.push(value)
            }
        },
        toggleModal() {
            this.modalOpen = true;
            this.modalToggle('activeModalInterval');
        },
        toggleModalLog(id) {
            this.logData = this.booking.logs.filter(p => p.id == id)[0];
            this.modalToggle('activeModalIntervalLog');
        },
        toggleModalSmsLog(id) {
            this.smsLogData = this.booking.smsLogs.filter(p => p.id == id)[0];
            this.modalToggle('activeModalIntervalSmsLog');
        },
        toggleModalType(id) {
            this.modalToggle('activeModalIntervalType');
        },
        toggleModalMessage() {
            this.modalToggle('activeModalMessage');
        },
        toggleModalForceSms() {
            this.modalToggle('activeModalForceSms');
        },
        toggleModalCopyBooking() {
            this.modalToggle('activeModalCopyBooking');
        },
        toggleModalChangePrice() {
            this.modalToggle('activeModalChangePrice');
        },
        getImageArray(imageString) {
            return imageString ? imageString.split(',').map(img => img.trim()) : [];
        },
        downloadPod(image, id, type, index = 0) {
            axios({
                url: `/optimoroute/download-pod/${id}/${type}/${index}`,
                method: 'POST',
                responseType: 'blob',
                data: image
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', image);
                document.body.appendChild(link);
                link.click();
            }); // @todo catch error
        },
        downloadCompletePod(id) {
            if (this.loading) {
                return;
            }
            this.loading = true;
            axios({
                url: `/optimoroute/download-complete-pod/${id}`,
                method: 'POST',
                responseType: 'blob'
            }).then(response => {
                console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${id}.pdf`);
                document.body.appendChild(link);
                link.click();
            }).finally(() => {
                this.loading = false;
            });
        },
        recalculateTimeUnitsProduct(event, id, time_unit_old) {
            const productUnit = parseFloat(event.target.value);
            if (productUnit > 0) {
                if (time_unit_old > 0) {
                    this.booking.product_price = parseFloat(productUnit * this.booking.product_price / time_unit_old).toFixed(2);
                }
                this.booking.product_time_units = productUnit;
            } else if (productUnit === 0) {
                this.booking.product_time_units = 0;
            }
        },
        recalculateTimeUnitsService(event, id, time_unit_old) {
            const serviceUnit = parseFloat(event.target.value);
            if (serviceUnit > 0) {
                let serviceDataEditable = this.booking.services_data.filter(p => p.id == id);
                if (time_unit_old > 0) {
                    serviceDataEditable[0].price = parseFloat(serviceUnit * serviceDataEditable[0].price / time_unit_old).toFixed(2);
                }
                serviceDataEditable[0].time_unit = serviceUnit;
            } else if (serviceUnit === 0) {
                let serviceDataEditable = this.booking.services_data.filter(p => p.id == id);
                serviceDataEditable[0].time_unit = 0;
            }
        },
        redirectToCreateRebookingPage() {
            window.location.href = `/bookings/${this.booking.id}/create-rebooking`;
        },
        changeBookingTypeModal() {
            this.modalOpen = true;
            this.modalToggle('activeModalIntervalType');
        },
        changeBookingType() {
            if (this.booking.booking_type === 1) {
                this.booking.booking_type = 2
            } else {
                this.booking.booking_type = 1;
                this.booking.cost_price = 0;
            }
            this.toggleModalType();
        },
        smsSend(smsTemplate, force = false) {
            const address = smsTemplate.send_to === this.sendToDropoff ? 'dropoff_address' : 'pickup_address'
            this.selectedSmsTemplate = {};

            console.log(address);
            console.log(this.booking[address].phone);
            if (this.booking.is_delivery_from_warehouse) {
                this.flashMessage.error({
                    title: '',
                    message: 'Booking is delivered from warehouse',
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                return;

            } else if (!this.booking[address].phone) {
                this.flashMessage.error({
                    title: '',
                    message: `The phone is missing in ${address}`,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                return;
            }

            this.selectedSmsTemplate = smsTemplate;

            this.sendSms(smsTemplate.id, [{
                bookingId: this.booking.id,
                customerName: this.booking[address].name,
                phone: this.booking[address].phone
            }], force)
                .then((result) => {
                    if (result.errors[this.booking.id] &&
                        result.errors[this.booking.id] === `Sms ${smsTemplate.id} has already been sent for the booking ${this.booking.id}`
                    ) {
                        this.toggleModalForceSms();
                    }
                });
        },
        analyzeCustomerOptions() {
            if (this.booking.customerOptions.length) {
                for (let i = 0; i < this.booking.customerOptions.length; i++) {
                    if (undefined !== this.booking.customerOptions[i].options[this.permitsKey] &&
                        this.booking.customerOptions[i].options[this.permitsKey].enabled
                    ) {
                        this.bookingPermits.push(this.booking.customerOptions[i].options[this.permitsKey].name)
                    }

                    if (undefined !== this.booking.customerOptions[i].options[this.insuranceKey] &&
                        this.booking.customerOptions[i].options[this.insuranceKey].enabled
                    ) {
                        this.insuranceInCustomerOptions = true;
                    }
                }
            }
        },
        calcTotalExclVat() {
            let total = this.booking.total_service_price + parseFloat(this.booking.product_price) -
                parseFloat(this.booking.deadline_fee) + parseFloat(this.booking.storage_fee);
            if (!this.insuranceInCustomerOptions) {
                total += parseFloat(this.booking.insurances_price);
            }

            if (this.selectedAddOnsPickup.length) {
                this.selectedAddOnsPickup.map(item => {
                    if (item.price) {
                        total += parseFloat(item.price);
                    }
                });
            }

            if (this.selectedAddOnsDropoff.length) {
                this.selectedAddOnsDropoff.map(item => {
                    if (item.price) {
                        total += parseFloat(item.price);
                    }
                });
            }

            if (this.booking.customServices) {
                this.booking.customServices.map(item => {
                    if (item.price) {
                        total += parseFloat(item.price);
                    }
                });
            }
            return total;
        },
        calcTotalForLog(data) {
            let totalPrice = 0;
            for (let key in data) {
                if ([this.primeKey, this.addOnsKey].includes(data[key].key)) {
                    for (let i in data[key]) {
                        if (typeof data[key][i] === 'object') {
                            totalPrice += Number(this.logOptionPrice(
                                data[key][i].price ? data[key][i].price : 0
                            ));
                        }
                    }
                } else {
                    totalPrice += Number(this.logOptionPrice(
                        data[key].price ? data[key].price : 0
                    ));
                }
            }

            return totalPrice;
        },
        checkMaxInterval() {
            if (this.maxIntervalExceeded && !this.booking.total_price) {
                this.warningMessage = 'Volume/weight of colli exceeds the max interval, so price has been set to 0.' +
                    ' Please adjust the price accordingly.'
                this.toggleModalMessage();
            }
        },
        goBack() {
            sessionStorage.setItem('applyBookingsSearchString', '1');
            window.location.href = this.backUrl;
        },
        copyBooking() {
            axios.post(`/bookings/${this.booking.id}/copy`, this.bookingCopy)
                .then((response) => {
                    console.log(response.data);
                    this.flashMessage.success({
                        title: '',
                        message: `The booking has been copied successfully`,
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    this.toggleModalCopyBooking();
                }).catch((error) => {
                console.log(error.response);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message || error.response.data || 'Error',
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            });
        },
        disabledDates(date) {
            const startFrom = moment().toDate();
            startFrom.setHours(0, 0, 0, 0);

            return date < startFrom;
        },
        hasSpecialPermission(permission) {
            return this.specialPermissions?.[permission] === true;
        },
        tripCanBeMarkedAsForeign(trip, address) {
            return address.country.name !== 'Denmark';
        },
        driverCostExclusionFlagField(type) {
            return `exclude_${type}_from_driver_cost_report`;
        },
        driverCostExclusionNoteField(type) {
            return `${type}_driver_cost_report_exclusion_note`;
        },
        onChangeExcludeFromDriverCostReport(type) {
            if (this.excludeFromDriverCostReport[type]) {
                this.openDriverCostExclusionNoteModal('exclude', type);
            } else {
                this.driverCostExclusionType = type;
                this.modalToggle('activeModalDriverCostExclusionRemoval');
            }
        },
        openDriverCostExclusionNoteModal(mode, type) {
            this.driverCostExclusionNoteMode = mode;
            this.driverCostExclusionType = type;
            this.driverCostExclusionNoteDraft = this.booking[this.driverCostExclusionNoteField(type)] || '';
            this.driverCostExclusionNoteError = '';
            this.modalToggle('activeModalDriverCostExclusionNote');
        },
        confirmDriverCostExclusionNote() {
            const note = this.driverCostExclusionNoteDraft.trim();
            if (!note) {
                this.driverCostExclusionNoteError = 'Please enter a reason.';
                return;
            }

            const type = this.driverCostExclusionType;
            this.$set(this.booking, this.driverCostExclusionNoteField(type), note);
            this.$set(this.booking, this.driverCostExclusionFlagField(type), true);
            this.$set(this.excludeFromDriverCostReport, type, true);
            this.modalToggle('activeModalDriverCostExclusionNote');
        },
        cancelDriverCostExclusionNote() {
            if (this.driverCostExclusionNoteMode === 'exclude') {
                this.$set(this.excludeFromDriverCostReport, this.driverCostExclusionType, false);
            }
            this.driverCostExclusionNoteError = '';
            this.modalToggle('activeModalDriverCostExclusionNote');
        },
        confirmDriverCostExclusionRemoval(deleteNote) {
            const type = this.driverCostExclusionType;
            this.$set(this.booking, this.driverCostExclusionFlagField(type), false);
            if (deleteNote) {
                this.$set(this.booking, this.driverCostExclusionNoteField(type), null);
            }
            this.$set(this.excludeFromDriverCostReport, type, false);
            this.modalToggle('activeModalDriverCostExclusionRemoval');
        },
        cancelDriverCostExclusionRemoval() {
            this.$set(this.excludeFromDriverCostReport, this.driverCostExclusionType, true);
            this.modalToggle('activeModalDriverCostExclusionRemoval');
        },
        addNewCustomService(name) {
            if (name) {
                this.booking.customServices.push({name: name, price: 0});
                this.newCustomService = '';
                this.selectedCustomService = '';
            }
        },
        deleteCustomService(index) {
            this.booking.customServices.splice(index, 1);
        },
        onSelectAddOn(type) {
            const prefix = type === this.tripTypePickup ? 'Pickup' : 'Dropoff';
            this[`showShorterIntervalOptions${prefix}`] = false;
            this[`selectedAddOns${prefix}`].forEach((selectedAddOn) => {
                if (this[`addOnShorterInterval${prefix}`] === selectedAddOn.add_on_id) {
                    this[`showShorterIntervalOptions${prefix}`] = true;

                    if (!this.selectedAddOnOptions[selectedAddOn['add_on_id']] && selectedAddOn.configurations) {
                        let arr = selectedAddOn.configurations.filter((item) => {
                            return item['option'];
                        });
                        this.$set(this.selectedAddOnOptions, selectedAddOn['add_on_id'], arr[0]);
                    }

                    this.onSelectAddOnOption(selectedAddOn.add_on_id, type);
                }
            });
        },
        onSelectAddOnOption(k, type) {
            console.log(k, type);
            const prefix = type === this.tripTypePickup ? 'Pickup' : 'Dropoff';
            console.log(prefix);
            this[`selectedAddOns${prefix}`].forEach((selectedAddOn, i) => {
                if (selectedAddOn.add_on_id === k) {
                    this.$set(this[`selectedAddOns${prefix}`][i], 'price', this.selectedAddOnOptions[k].price);
                    this.$set(this[`selectedAddOns${prefix}`][i], 'selected_option', this.selectedAddOnOptions[k].option ?? null);
                }
            });

            if (this[`addOnShorterInterval${prefix}`] === k) {
                let times = this.selectedAddOnOptions[k].option.split('-');
                if (times[1]) {
                    if (type === this.tripTypePickup) {
                        this.$set(this.booking, 'pickup_start', times[0].trim())
                        this.$set(this.booking, 'pickup_end', times[1].trim())
                    }

                    if (type === this.tripTypeDropoff) {
                        this.$set(this.booking, 'dropoff_start', times[0].trim())
                        this.$set(this.booking, 'dropoff_end', times[1].trim())
                    }
                }
            }
        },
        handleDropoffDateChange() {
            if (this.booking.dropoff_date !== this.previousDropoffDate) {
                this.getFeesInfo(this.booking.dropoff_date).then((data) => {
                    if (data.status === 'success') {
                        this.calculatedFees.storage_fee_value = data.data.storage_fee_value;
                        this.calculatedFees.deadline_fee_value = data.data.deadline_fee_value;
                        this.modalToggle('showDropoffConfirmModal');
                    } else if (data.status === 'error') {

                        // for the moment do nothing - need to clarify is it ok to change date without full colli set

                        // this.flashMessage.error({
                        //     title: 'Error',
                        //     message: data.message,
                        //     time: 5000,
                        //     blockClass: 'flash-message error'
                        // });
                        // this.booking.dropoff_date = this.previousDropoffDate;
                    }
                });
            }
        },
        async getFeesInfo(customDate) {
            try {
                const response = await axios.get(`/bookings/${this.booking.id}/get-storage-deadline-data?customDropoffDate=${customDate}`);
                return response.data;
            } catch (e) {
                console.error(e);
                return e.response.data || {status: 'error', message: 'An error occurred while calculating fees.'};
            }
        },
        confirmDropoffDateChange() {
            if (!this.storageFeeConfirmed && !this.storageFeeConfirmed) {
                return;
            }
            this.previousDropoffDate = this.booking.dropoff_date;
            this.booking.storage_fee_confirmed = this.storageFeeConfirmed;
            this.booking.deadline_fee_confirmed = this.deadlineFeeConfirmed;
            this.booking.storage_fee_value = this.calculatedFees.storage_fee_value;
            this.booking.deadline_fee_value = this.calculatedFees.deadline_fee_value;
            this.modalToggle('showDropoffConfirmModal');
        },
        cancelDropoffDateChange() {
            this.booking.dropoff_date = this.previousDropoffDate;
            this.storageFeeConfirmed = this.booking.storage_fee_confirmed;
            this.deadlineFeeConfirmed = this.booking.deadline_fee_confirmed;
            this.modalToggle('showDropoffConfirmModal');
        },
        onFeeSelect(feeType) {
            if (feeType === 'storage_fee' && this.storageFeeConfirmed) {
                this.deadlineFeeConfirmed = 0;
            } else if (feeType === 'deadline_fee' && this.deadlineFeeConfirmed) {
                this.storageFeeConfirmed = 0;
            }
        },
        getAvailableWeekDays(type, zip) {
            return new Promise((resolve) => {
                this[`availableWeekDays${type}`] = {
                    1: {from: '00:00', to: '00:00', highlight: false},
                    2: {from: '00:00', to: '00:00', highlight: false},
                    3: {from: '00:00', to: '00:00', highlight: false},
                    4: {from: '00:00', to: '00:00', highlight: false},
                    5: {from: '00:00', to: '00:00', highlight: false},
                };
                if (!zip || zip.length < 4) {
                    resolve();
                    return;
                }

                setTimeout(() => {
                    axios.get(`/routes-get-week-days`, {
                            params: {
                                zip: zip,
                                totalVolume: this.booking.volume,
                                totalWeight: this.booking.weight,
                            }
                        })
                        .then((response) => {
                            if (response.data.availableDays && Object.keys(response.data.availableDays).length) {
                                this[`availableWeekDays${type}`] = response.data.availableDays;
                            }
                        }).catch((error) => {
                        console.log(error.response.data);
                    }).finally(() => {
                        resolve();
                    });
                }, 500);
            });
        },
        getClassesPickup(date) {
            if (this.role === this.roleUser) {
                return '';
            }

            let day = date.getDay().toString();
            if (this.booking.pickup_address.zip &&
                (
                    Object.keys(this.availableWeekDaysPickup).length &&
                    Object.keys(this.availableWeekDaysPickup).includes(day) &&
                    this.availableWeekDaysPickup[day].highlight
                )
            ) {
                return 'text-white bg-success font-weight-bold';
            }

            return '';
        },
        getClassesDropoff(date) {
            if (this.role === this.roleUser) {
                return '';
            }

            let day = date.getDay().toString();
            if (this.booking.dropoff_address.zip &&
                (
                    Object.keys(this.availableWeekDaysDropoff).length &&
                    Object.keys(this.availableWeekDaysDropoff).includes(day) &&
                    this.availableWeekDaysDropoff[day].highlight
                )
            ) {
                return 'text-white bg-success font-weight-bold';
            }

            return '';
        },
        onSelectDatePickup(date) {
            this.setHourRange(date, 'Pickup');
        },
        onSelectDateDropoff(date) {
            this.setHourRange(date, 'Dropoff');

        },
        setHourRange(date, type) {
            if (this.role === this.roleUser) {
                return;
            }

            setTimeout(() => {
                let startTimePicker = this.$refs[`${type}StartTime`];
                let endTimePicker = this.$refs[`${type}EndTime`];
                let ul, elements;
                let day, from, to, timeRange;

                if (!startTimePicker && !endTimePicker) {
                    return;
                }

                if (date) {
                    date = new Date(date);
                    day = date.getDay().toString();
                }

                let hasAvailableTimeRange = false;
                if (day !== undefined &&
                    this[`availableWeekDays${type}`][day] &&
                    this[`availableWeekDays${type}`][day]['from'] &&
                    this[`availableWeekDays${type}`][day]['to'] &&
                    (this[`availableWeekDays${type}`][day]['from'] !== '00:00' || this[`availableWeekDays${type}`][day]['from'] !== '00:00')
                ) {
                    from = this[`availableWeekDays${type}`][day]['from'];
                    to = this[`availableWeekDays${type}`][day]['to'];
                    hasAvailableTimeRange = true;
                }

                if (from && to) {
                    const range = [from.substring(0, 2), to.substring(0, 2)];
                    // Highlight hours selected on a route
                    const start = parseInt(range[0], 10);
                    const end = parseInt(range[1], 10);

                    timeRange = Array.from(
                        {length: end - start + 1},
                        (_, i) => String(start + i).padStart(2, "0")
                    );
                }

                for (let picker of [startTimePicker, endTimePicker]) {
                    ul = picker.querySelector('.hours');
                    elements = ul.querySelectorAll('li');
                    for (const element of elements) {
                        element.classList.remove('bg-success');
                        if (hasAvailableTimeRange && timeRange && timeRange.includes(element.dataset.key)) {
                            element.classList.add('bg-success');
                        }
                    }
                }
            }, 50);
        },
        reload() {
            window.location.reload();
        }
    },
    watch: {
        'booking.dropoff_address.zip'(newVal) {
            this.getAvailableWeekDays('Dropoff', newVal).then(() => {
                if (this.booking.dropoff_date) {
                    this.setHourRange(this.booking.dropoff_date, 'Dropoff');
                }
            });
        },
        'booking.pickup_address.zip'(newVal) {
            this.getAvailableWeekDays('Pickup', newVal). then(() => {
                if (this.booking.pickup_date) {
                    this.setHourRange(this.booking.pickup_date, 'Pickup');
                }
            });
        },
    },
    created() {
        this.fetchData();
        let future2BusinessDays = moment().add(2, 'days');
        while (['Saturday', 'Sunday'].includes(future2BusinessDays.format('dddd'))) {
            future2BusinessDays = future2BusinessDays.add(1, 'days');
        }
        setTimeout(() => {
            this.$set(this.bookingCopy, 'dropoffDate', future2BusinessDays.format('DD-MM-YYYY'));
            this.$set(this.bookingCopy, 'pickupDate', future2BusinessDays.format('DD-MM-YYYY'));
        }, 10);

        let options = [];
        this.agreementAddOnsPickup.forEach((agreementAddOn) => {
            if (agreementAddOn.add_on_id === this.addOnShorterIntervalPickup) {
                options = [];
                let option;
                for (let j in agreementAddOn.configurations) {
                    option = agreementAddOn.configurations[j]['option'] ??
                        `${agreementAddOn.configurations[j]['from']} - ${agreementAddOn.configurations[j]['to']}`

                    options.push({
                        option: option,
                        price: agreementAddOn.configurations[j]['price']
                    });
                }
                this.$set(this, 'shorterIntervalOptionsPickup', options);
            }
        });

        this.agreementAddOnsDropoff.forEach((agreementAddOn) => {
            if (agreementAddOn.add_on_id === this.addOnShorterIntervalDropoff) {
                options = [];
                let option;
                for (let j in agreementAddOn.configurations) {
                    option = agreementAddOn.configurations[j]['option'] ??
                        `${agreementAddOn.configurations[j]['from']} - ${agreementAddOn.configurations[j]['to']}`

                    options.push({
                        option: option,
                        price: agreementAddOn.configurations[j]['price']
                    });
                }
                this.$set(this, 'shorterIntervalOptionsDropoff', options);
            }
        })
    },
}
</script>
<style scoped>
.status-block {
    width: 165px;
    height: 56px;
    background: rgba(89, 165, 145, 0.16);
    border-radius: 8px;
}

.status-block-inactive {
    width: 165px;
    height: 56px;
    background: #F9F9F9;
    border-radius: 8px;
}

.status-text {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #59A591;
}

.status-text-inactive {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #777777;
}

.border-bottom-status {
    border-bottom: 4px solid #59A591 !important;
}

span.status-label {
    margin-left: 10px;
}

.status-icons {
    display: block !important;
}

.fixed-height-500 {
    min-height: 500px;
}

.action-block {
    margin-top: 20px;
}

.confirm-button {
    margin-left: 10px;
}

.colli-number {
    position: relative;
    bottom: 6px;
}

.trip-actions {
    display: inline-block;
    width: 150px;
}

.pod-button {
    margin-bottom: 5px;
}

.rebooking {
    font-style: italic;
    font-size: 10px;
}

.status-block-error {
    background-color: red;
    opacity: 70%;
}
.mx-datepicker input {
    outline: none;
    margin-left: 0px !important;
}

.driver-cost-exclusion-note {
    padding: 10px 12px;
    border-left: 3px solid #883b6f;
    border-radius: 4px;
    background: #f8f3f7;
    color: #4a3443;
}

.driver-cost-exclusion-note__content {
    margin-bottom: 4px;
}

.driver-cost-exclusion-note__text {
    white-space: pre-wrap;
    word-break: break-word;
}
</style>
